import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy,
  inject
} from '@angular/core';
import { forkJoin, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { InventoryService } from 'projects/service/src/app/modules/home/services/inventory.service';
import { ApiResponse, Companies, gridNames, GridPersistRequests, PartsAvailabilityStatus, PersistenceData, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { CostTypes, CostTypesList, ModeList, SubCostTypeList, SubCostTypes } from '../../models/service-order.model';
import { ExecutionTabService } from '../../services/execution-tab.service';
import { ServiceOrderService } from '../../services/service-order.service';
import { ToolbarClickEventArgs } from '@syncfusion/ej2-angular-richtexteditor';
import { MasterItemcodePopupComponent } from 'projects/shared/src/lib/components/master-itemcode-popup/master-itemcode-popup.component';
import { ActionIconDef, Grid as InavistaGrid, GridActionIconClickEvent, GridColumnInfo, GridConfig, GridHyperlinkClickEvent, GridRowCommitEvent, GridRowEditStartEvent, GridRowProblem } from '@inavista/components/grid';
import { CellEdit, DateTimeEditor, DropdownEditor, NumberEditor, TextEditor } from 'projects/service/src/app/shared/utils/cell-editors';
import { ADD_TRANSACTION_ACTION, buildTransactionsActionIcons, buildTransactionsGridConfig, TRANSACTIONS_PERSISTENCE_KEY, TRANSACTION_COMMANDS, TRANSACTION_OPEN_FIELD, transactionEditFields, transactionFields, TRANSACTIONS_URL, TransactionsGridContext } from './transactions.grid.config';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { ADD_ASSIGNMENT_ACTION, ASSIGNMENT_COLUMNS, ASSIGNMENTS_PERSISTENCE_KEY, AssignmentsGridContext, buildAssignmentsActionIcons, buildAssignmentsGridConfig } from './assignments.grid.config';

@Component({
    selector: 'app-execution-tab',
    templateUrl: './execution-tab.component.html',
    styleUrls: ['./execution-tab.component.scss'],
    providers: [
        // The Assignments grid reads this.assignments, not an endpoint.
        ...provideLocalGridRows()
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ExecutionTabComponent implements OnInit, OnChanges {

  private destroy$: Subject<null> = new Subject();

  serviceTypes = [];
  @Input() data = null;
  @Input() equipmentInfoData = null;
  @Input() configurationId = null;
  @Input() distanceZone = null;
  @Input() customerCurrency = 'USD';
  @Input() isEditable: boolean;
  @Input() fieldRules: any;
  @Input() assignments = [];
  @Input() assignmentDetails = [];
  @Input() taxRates = [];
  @Input() checkinTime: any = null;
  @Input() costTypes = CostTypesList;

  preference: any;
  isOffline: boolean;
  isIsc: boolean;
  isIscManager: boolean;
  isKingslynn: boolean = false;
  ddlFetched: boolean = false;
  showAssignmentsPopup: boolean = false;
  showCartCheckoutPopup: boolean = false;
  getPriceForItem: boolean = true;
  itemChangedFromAdvanceSearch: boolean = false;
  assignmentsConfig: GridConfig = null;
  assignmentsActionIcons: ActionIconDef[] = [];
  /** A row of the Assignments grid has unsaved changes (the old assignmentsGrid.isEdit). */
  assignmentEditing = false;
  refActivityOptions: { value: any; label: string }[] = [];
  reportedProblemOptions: { value: any; label: string }[] = [];
  solutionOptions: { value: any; label: string }[] = [];
  priorityOptions: { value: any; label: string }[] = [];
  /** When the open row was opened: the earliest Start / End Date of a row with none yet, as the old pickers' min. */
  assignmentEditStartedAt = new Date();
  refActivityEditorShown = true;
  lastClickedAssignment: any = null;
  selectedAssignment = null;
  warranty = '';
  contract = '';
  USER;

  fromExecutionTab: any;

  coreItemGroup = ['450SVC'];

  isTabValid: boolean = true;
  mandatoryItem: boolean = false;
  showAssignmentDetailsPopup: boolean = false;
  skipBeginEditEvent: boolean = false;
  assignmentDetailGrid = null;
  selectedAssignmentDetail = null;
  /**
   * Set this variable if there is only one assignment and reset to null once reference assignment value is populated.
   * We are using this to populate Reference Activity by default if there is only one assignment in assignmentsGrid
   */
  defaultReferenceActivity = null;

  @ViewChild('assignmentTemplate') assignmentTemplate: any;
  @ViewChild('assignmentsGrid') assignmentsGrid: InavistaGrid;
  @ViewChild('refActivityEditor', { static: true }) refActivityEditor: TemplateRef<unknown>;
  @ViewChild('reportedProblemEditor', { static: true }) reportedProblemEditor: TemplateRef<unknown>;
  @ViewChild('solutionEditor', { static: true }) solutionEditor: TemplateRef<unknown>;
  @ViewChild('priorityEditor', { static: true }) priorityEditor: TemplateRef<unknown>;
  @ViewChild('startDateEditor', { static: true }) startDateEditor: TemplateRef<unknown>;
  @ViewChild('endDateEditor', { static: true }) endDateEditor: TemplateRef<unknown>;
  @ViewChild('transactionsGrid') transactionsGrid: InavistaGrid;
  @ViewChildren('txEditor') txEditorTemplates: QueryList<TemplateRef<unknown>>;
  /** The Transactions grid as the old code knew it (see createTransactionsGridShim). */
  readonly assignmentDetailsGrid: any = this.createTransactionsGridShim();
  transactionsConfig: GridConfig = null;
  transactionsActionIcons: ActionIconDef[] = [];
  /** A transaction row is open for editing (the old assignmentDetailsGrid.isEdit). */
  transactionEditing = false;
  /** The new row Add built (setAssignmentDetailRow); it joins this.assignmentDetails when it is saved. */
  pendingNewTransaction: any = null;
  /** The cells drawn with the column's editor (CellEditorHost), and those the grid edits itself (Comments). */
  txEditFields: string[] = [];
  txBuiltInEditFields: string[] = [];
  /** The editors of the open row, by field (CellEditorHost). */
  readonly txOpenEditors = new Map<string, CellEdit>();
  private txSchema: GridColumnInfo[] = [];
  private txContext: TransactionsGridContext = null;
  lastClickedTransaction: any = null;
  /** The open row and its hidden columns: Syncfusion drew an editor for every column, hidden ones included (in hidden
   *  cells), and read them all on save; the old code relies on those editors, so they are drawn out of sight. */
  txHiddenRow: any = null;
  txHiddenEditFields: string[] = [];

  @Output() tabUpdated = new EventEmitter();
  @Output() showPartsOrderPopup: EventEmitter<any> = new EventEmitter();

  warehouse: string;

  referenceActivities = [];
  reportedProblems = [];
  solutions = [];
  priorities = [];
  units = [];
  serviceItems = [];
  returnReasons = [];
  descriptionObject: TextEditor;

  assignmentObject: DropdownEditor;

  assignmentDetailReferenceActivityObject: TextEditor;
  assignmentDetailReferenceActivityDescription: any;
  assignmentDetailReferenceActivityCode: any;

  assignmentDetailServiceTypeObject: TextEditor;
  assignmentDetailServiceTypeCode: any;
  assignmentDetailServiceTypDescription: any;

  commentsObject: TextEditor;

  costTypeObject: DropdownEditor;

  subcostTypeObject: DropdownEditor;

  itemGroup: any;
  serviceItemGroup: any;
  rowServiceItemGroup: any;

  itemCodeObject: DropdownEditor;

  selectedRowId: string;
  showItemAdvancedSearchPopup: boolean = false;
  onItemUpdate = new Subject<string>();
  itemsList = [];

  itemDescriptionObject: TextEditor;

  quantityObject: NumberEditor;
  onHandQuantity;

  discountAmountObject: NumberEditor;

  warrantyAmountObject: NumberEditor;

  contractAmountObject: NumberEditor;

  priceObject: NumberEditor;

  totalAmount: any = 0;
  totalAmountValue: any;
  totalAmountObject: NumberEditor;

  tempUnit: string = '';
  unitObject: DropdownEditor;
  unitCode: any;

  returnReasonObject: DropdownEditor;

  currencyObject: TextEditor;

  assignmentDetailStartTimeValue: any;
  assignmentDetailStartTimeObject: DateTimeEditor;

  assignmentDetailEndTimeObject: DateTimeEditor;

  taskValue: string;
  taskObject: TextEditor;

  taxAmount: any;
  taxObject: NumberEditor;

  taxPercentObject: NumberEditor;

  laborTypeObject: TextEditor;

  costComponentValue: string;
  costComponentObject: TextEditor;

  transactionWarehouseObject: TextEditor;

  costTypes1 = [
    { text: 'Material', value: 'Material' },
    { text: 'Other Cost', value: 'Costitem' }
  ];

  activityId: any;
  assignmentId: any;
  assignmentDetailId: any;
  warrantyInfo: any;
  contractInfo: any;

  priceValue: any = 0;
  quantityValue: any = 0;
  discountValue: any = 0;
  startTimeValue: any;
  laborRate: any = 0;
  calloutRate: any = 0;
  modelDescription: any;
  serialNumber: any;


  loadedAssignmentItemDetails: any = [];

  assignmentDetailAction: string = '';
  showLoader: boolean = false;
  assignmentsReadOnly: boolean = false;
  transactionsReadOnly: boolean = false;

  private readonly assignmentsRows = inject(LocalRowsGridApi);
  private readonly transactionsRows = inject(LocalRowsGridApi);

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private executionTabService: ExecutionTabService,
    private serviceOrderService: ServiceOrderService,
    private inventoryService: InventoryService,
    private eRef: ElementRef
  ) {
    this.USER = this.commonService.USER;
    this.assignmentsReadOnly = this.commonService.roleClaims['SO_Popup_Field_assignments']?.readOnly;
    this.transactionsReadOnly = this.commonService.roleClaims['SO_Popup_Fields_transactions']?.readOnly;
  }

  showMasterItemCodePopup(eqData: any) {
    if (!eqData?.itemCode) return;
    const dialogRef = this.dialog.open(MasterItemcodePopupComponent, {
      panelClass: 'master-itemcode-popup-dialog',
      width: '80%',
      height: '80%',
      data: eqData
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  @HostListener('document:click', ['$event'])
  // A click elsewhere saves the open row, as before: Transactions through endEdit, Assignments through saveBatch.
  onClick(event) {
    const target = event.target as HTMLElement;
    // A click on something already gone (a list option: picking it closed the list) was not a click elsewhere.
    if (!target?.isConnected) return;
    // Not a click in the Assignments grid, its editors' lists and calendars, or a confirmation.
    if (this.assignmentEditing && !target?.closest?.('.assignments-grid, [class*="inavista"], .swal2-container')) {
      this.assignmentsGrid?.saveBatch();
    }
    const grid = this.assignmentDetailsGrid?.isEdit ? this.assignmentDetailsGrid : null;
    // Not a click in the grid, or in what opens over the open row (the item search, a dialog, a confirmation, a list):
    // the old Syncfusion popups were skipped by their classes below; the new ones are skipped here.
    if (grid?.isEdit && !target?.closest?.('.transactions-grid, app-items-advanced-search, .cdk-overlay-container, .swal2-container, [class*="inavista"]')) {
      const excludedClasses = ['e-ddl', 'e-popup', 'e-lib', 'e-control', 'e-popup-close', 'e-day', 'loader-container'];
      let targetElement = event.target as HTMLElement;
      while (targetElement) {
        if (excludedClasses.some(className => targetElement.classList.contains(className))) {
          event.stopPropagation();
          return;
        }
        targetElement = targetElement.parentElement;
      }
      grid.endEdit();
    }
  }

  ngOnInit(): void {
    this.warehouse = this.data?.technicianWarehouse || this.USER.warehouse;
    this.isOffline = this.data?.offlineOrder;
    this.isIsc = this.USER.role === UserRoles.isc;
    this.isIscManager = this.USER.role === UserRoles.iscManager;
    this.data.warrantyCoverageLines && (this.warrantyInfo = JSON.parse(this.data.warrantyCoverageLines));
    this.data.contractCoverageLines && (this.contractInfo = JSON.parse(this.data.contractCoverageLines));


    this.isKingslynn = this.USER.company === Companies.kingslynn
    this.serviceOrderService.nteChange.pipe(
      takeUntil(this.destroy$),
    ).subscribe((args: any) => {
      if (args.value) {
        this.data.approvedAmount = args.value;
      }
    });
    this.serviceOrderService.modelDescriptionChange.subscribe(modelDescription => {
      this.modelDescription = modelDescription;
    });

    this.serviceOrderService.callgroupChange.pipe(
      takeUntil(this.destroy$)
    ).subscribe(callGroup => {
      this.executionTabService.getReferenceActivities(this.USER.company, callGroup).subscribe((res: ApiResponse) => {
        this.referenceActivities = res.result.map(activity => {
          activity.text = activity.description;
          return activity;
        });
      });
    });

    this.serviceOrderService.serialNumberChange.pipe(
      takeUntil(this.destroy$),
    ).subscribe((args: any) => {
      if (args.itemData && args.itemData.serialNumber) {
        this.serialNumber = args.itemData.serialNumber;
      }
    });

    this.serviceOrderService.equipmentInfoSubject.pipe(
      takeUntil(this.destroy$),
    ).subscribe(equipmentInfo => {
      if (equipmentInfo) {
        this.equipmentInfoData = equipmentInfo.data;
        this.warrantyInfo = equipmentInfo.warrantyInfo;
        this.contractInfo = equipmentInfo.contractInfo;
        this.equipmentInfoData.warrantyDescriptionObj = equipmentInfo.warrantyInfo;
        this.equipmentInfoData.serviceContractDescriptionObj = equipmentInfo.contractInfo;
      }
    });
    this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
    this.setLoadedAssignmentItemDetails(this.assignmentDetails);
    this.setPageData();
    this.loadTab();
    this.warranty = localStorage.getItem('warranty') || '';
    this.contract = localStorage.getItem('contract') || '';
    this.assignmentDetailStartTimeValue = this.checkinTime;
    if (this.USER.company === Companies.conway) {
      this.getItemList();
    }
    this.onItemUpdate
      .pipe(
        debounceTime(200),
        distinctUntilChanged()
      ).subscribe(value => {
        if (this.itemCodeObject) {
          this.itemCodeObject.showPopup();
          this.itemCodeObject.showSpinner();
        }
        this.getItemList({ itemCode: value });
      });
  }

  setLoadedAssignmentItemDetails(transactions) {
    this.loadedAssignmentItemDetails = transactions.map(x => {
      return {
        itemCode: x.itemCode,
        issuedQty: x.issuedQty
      }
    });
  }

  getItemList(rowData?) {
    const value = rowData?.itemCode || '';
    this.showLoader = true;
    let serviceItemGroup = '';
    if (rowData?.costType === CostTypes.otherCost || this.costTypeObject?.value === CostTypes.otherCost) {
      serviceItemGroup = '350SVC';
    }
    this.commonService.getItems(value, 30, this.USER.company, serviceItemGroup)
      .subscribe((res: ApiResponse) => {
        if (res && res.result && res.result.length) {
          res.result.map(item => {
            item.value = item.item;
            item.text = `${item.item} | ${item.itemDescription}`;
          });

          const existingItems = [];
          (this.assignmentDetailsGrid?.dataSource as any)?.forEach(transaction => {
            if (transaction.itemCode !== this.itemCodeObject?.value) {
              existingItems.push(transaction.itemCode);
            }
          });
          this.itemsList = res.result.filter(item => !existingItems.includes(item.value));
          if (this.itemCodeObject) {
            this.itemCodeObject.hideSpinner();
            this.itemCodeObject.dataSource = this.itemsList;
          }
          this.showLoader = false;
        } else {
          this.itemsList = [];
          if (this.itemCodeObject) {
            this.itemCodeObject.hideSpinner();
            this.itemCodeObject.dataSource = [];
          }
          this.showLoader = false;
        }
      });
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change && change.isEditable) { // Calls if mode changed
      // Do nothing . . .
      // If we want to do anything other than enable/disable we do that here
    }

    if (change && change.assignments && change.assignments.currentValue) {
      this.assignments = change.assignments.currentValue;
      if (this.assignments && this.assignments.length) {
        this.assignments.map(assignment => {
          assignment.tempId = parseInt(assignment.assignmentId);
        });
      }
      if (!change.assignments.firstChange && this.assignmentsConfig) {
        this.refreshAssignmentsGrid();
      }
    }

    if (change && change.taxRates && change.taxRates.currentValue) {
      this.taxRates = change.taxRates.currentValue;
    }

    if (change && change.distanceZone && change.distanceZone.currentValue) {
      this.distanceZone = change.distanceZone.currentValue;
      this.getCalloutChargeRate();
    }

    if (change && change.configurationId && change.configurationId.currentValue) {
      this.configurationId = change.configurationId.currentValue;
      this.getLaborRate();
    }

    if (change && change.assignmentDetails && change.assignmentDetails.currentValue) {
      this.assignmentDetails = change.assignmentDetails.currentValue;
      if (!change.assignmentDetails.firstChange) {
        this.assignmentDetailGrid.dataSource = change.assignmentDetails.currentValue;
        this.assignmentDetailsGrid.columns[2] = {
          field: 'assignmentId', headerText: 'Reference Activity *', width: 148, filter: { type: 'Excel' }, textAlign: 'Left',
          foreignKeyValue: 'referenceActivityDescription', foreignKeyField: 'tempId', showInColumnChooser: false, dataSource: this.assignments, edit: this.editAssignment()
        };
        this.assignmentDetailsGrid.refreshColumns();
        this.assignmentDetailsGrid.refresh();
      }
    }

    if (change && change.isEditable && change.isEditable.currentValue !== undefined && !change.isEditable.firstChange) {
      this.isEditable = change.isEditable.currentValue;
      // this.calculateAmounts(false);
      this.refreshGrids();
    }
  }

  // The Add buttons can only be used while the order is editable (In Progress). For Kingslynn, adding an assignment
  // is also blocked once there is a billable assignment. Used for both the button's look and its click handler.
  get isAddAssignmentDisabled(): boolean {
    return !this.isEditable || (this.USER.company === Companies.kingslynn && !!this.checkBillable());
  }

  get isAddTransactionDisabled(): boolean {
    return !this.isEditable;
  }

  refreshGrids() {
    this.assignmentsConfig && this.refreshAssignmentsGrid();
    this.assignmentDetailsGrid && this.assignmentDetailsGrid.refresh();
  }

  getLaborRate() {
    this.executionTabService.getLaborSalesRate(this.configurationId)
      .subscribe((response: ApiResponse) => {
        if (response && response.isSuccessful) {
          this.laborRate = response.result;
        }
      });
  }

  getCalloutChargeRate() {
    this.executionTabService.getCallOutCharge(this.distanceZone, 0)
      .subscribe((response: ApiResponse) => {
        if (response && response.isSuccessful && response.result) {
          this.calloutRate = response.result;
        }
      });
  }

  validate() {
    // saveBatch() saves the Assignments row still open (as endEdit did); a row that fails its checks stays open.
    this.assignmentsGrid?.saveBatch();
    this.assignmentDetailsGrid?.endEdit();
    if (this.assignmentEditing || this.assignmentDetailsGrid?.isEdit) {
      this.isTabValid = false;
      return false;
    } else {
      this.isTabValid = true;
      return true;
    }
  }

  setPageData() {
    if (!this.data) {
      this.data = {
        serviceOrderId: null,
        serviceType: null,
        salesAmount: 0,
        discountAmount: 0,
        warrantyCoverage: 0,
        contractCoverage: 0,
        invoiceAmount: 0,
        tax: 0,
        taxable: false,
        totalAmount: 0
      }
    } else {
      if (this.assignmentDetails && this.assignmentDetails.length) {
        this.calculateAmounts(true);
      }
    }
  }

  loadTab() {
    this.serviceOrderService.popupLoader.next(true);
    forkJoin([
      this.executionTabService.getServiceTypes(this.USER.company),
      this.executionTabService.getReferenceActivities(this.USER.company, this.data.callGroup),
      this.executionTabService.getReportedProblems(this.USER.company, this.data.serializedItemGroupCode),
      this.executionTabService.getSolutions(this.USER.company, this.data.serializedItemGroupCode),
      this.serviceOrderService.getPriorities(this.USER.company),
      this.executionTabService.getUnits(this.USER.company),
      this.executionTabService.getReturnReasons(this.USER.company)
    ]).subscribe((res: any) => {
      this.serviceTypes = res[0].result;
      this.referenceActivities = res[1].result.map(activity => {
        activity.text = activity.description;
        return activity;
      });
      this.reportedProblems = res[2].result.map(problem => {
        problem.text = problem.description;
        return problem;
      });
      this.solutions = res[3].result;
      this.priorities = res[4].result.map(priority => {
        priority.text = priority.description;
        return priority;
      });

      this.units = res[5].result.map(row => {
        row.text = row.description;
        return row;
      });

      this.returnReasons = res[6].result.map(row => {
        row.text = row.description;
        return row;
      });

      this.ddlFetched = true;
      this.initGrids();
      // this.data.priority = this.data.priority ? this.data.priority : this.priorities.find( priority => priority.text === 'Normal').value;
      this.serviceOrderService.popupLoader.next(false);
      this.commonService.getUserDefaults(this.data.technicianId ?? this.USER.userId);
    }, (error: HttpErrorResponse) => {
      this.serviceOrderService.popupLoader.next(false);
    });
    // this.executionTabService.getServiceTypes()
    // .subscribe( (res: any) => {
    //     this.serviceTypes = res.result;
    // });
  }

  initGrids() {
    if (this.assignments && this.assignments.length) {
      this.assignments.map((assignment, index) => {
        assignment.tempId = parseInt(assignment.assignmentId);
        assignment.rowId = index + 1;
      });
    }
    if (this.assignmentDetails && this.assignmentDetails.length) {
      this.assignmentDetails.map((detail, index) => {
        detail.tempId = parseInt(detail.assignmentDetailId);
        detail.rowId = index + 1;
      });
    }
    this.initAssignmentsGrid();
    this.initAssignmentDetailsGrid();
    this.setupTransactionsGrid();
  }

  // Assignments on @inavista/components: the rows are this.assignments, served by LocalRowsGridApi (no endpoint).
  initAssignmentsGrid() {
    this.assignmentsRows.columns.set(LocalRowsGridApi.schema(ASSIGNMENT_COLUMNS));
    this.reportedProblemOptions = this.reportedProblems.map(p => ({ value: p.value, label: p.description }));
    this.solutionOptions = this.solutions.map(s => ({ value: s.value, label: s.text }));
    this.priorityOptions = this.priorities.map(p => ({ value: p.value, label: p.text }));
    const ctx: AssignmentsGridContext = {
      persistenceKey: ASSIGNMENTS_PERSISTENCE_KEY,
      editors: {
        referenceActivityDescription: this.refActivityEditor,
        reportedProblemDescription: this.reportedProblemEditor,
        solutionDescription: this.solutionEditor,
        priorityText: this.priorityEditor,
        startDate: this.startDateEditor,
        endDate: this.endDateEditor,
      },
      editLockReason: row => this.assignmentEditLockReason(row),
      actionLockReason: row => this.assignmentActionLockReason(row),
      addDisabledReason: () => this.isAddAssignmentDisabled ? this.addAssignmentDisabledReason() : null,
    };
    this.assignmentsConfig = buildAssignmentsGridConfig(ctx);
    this.assignmentsActionIcons = buildAssignmentsActionIcons(ctx);
    this.refreshAssignmentsGrid();
  }

  // The rows the grid shows: the assignments not deleted, with the lists' text for each code (the old foreign-key columns).
  refreshAssignmentsGrid() {
    const label = (list: any[], value: any, field: string, fallback: any) =>
      list?.find(item => item.value === value)?.[field] ?? fallback ?? '';
    this.assignmentsRows.rows.set(this.assignments.filter(a => !a.isDeleted).map(a => ({
      ...a,
      referenceActivityDescription: label(this.referenceActivities, a.referenceActivityCode, 'description', a.referenceActivityDescription),
      reportedProblemDescription: label(this.reportedProblems, a.reportedProblem, 'description', a.reportedProblemDescription),
      solutionDescription: label(this.solutions, a.solutionCode, 'text', a.solutionDescription),
      priorityText: label(this.priorities, a.priority, 'text', ''),
    })));
    this.assignmentsGrid?.refresh();
  }

  // Why a row can't be opened for inline editing (the old beginEdit cancels), or null.
  assignmentEditLockReason(row: any): string | null {
    if (!this.isEditable) return 'Assignments can be changed while the order is In Progress.';
    if (this.assignmentsReadOnly) return 'You do not have permission to change assignments.';
    if (this.assignmentDetailsGrid?.isEdit) return 'A transaction is being edited. Save or cancel it first.';
    // Kingslynn: the first assignment can't be edited.
    const first = this.assignments.find(a => !a.isDeleted);
    if (this.USER.company === Companies.kingslynn && first && first.rowId === row.rowId && row.referenceActivityCode) {
      return 'The first assignment of a Kingslynn order can\'t be edited.';
    }
    return null;
  }

  // Why a row's Edit and Delete icons are disabled (the old rowDataBound rule), or null.
  assignmentActionLockReason(row: any): string | null {
    if (this.isEditable && this.data.offlineOrder) return null;
    if (this.USER.company === Companies.kingslynn && row.rowId > 1) return null;
    if (this.isEditable && (!row.assignmentId || !row.activityIdLN || row.activityIdLN !== '10')) return null;
    return this.isEditable ? 'This assignment was sent to LN and can\'t be changed here.' : 'Assignments can be changed while the order is In Progress.';
  }

  addAssignmentDisabledReason(): string {
    return !this.isEditable
      ? 'Assignments can be added while the order is In Progress.'
      : 'A Kingslynn order with a billable assignment can\'t get another assignment.';
  }

  // A double click on a locked row says why, as the old grid's notifications did.
  // A double click on a locked row says why, as the old grid did on beginEdit. The grid has no double-click output,
  // so the row comes from its click and the double click from the wrapper.
  onAssignmentDoubleClick() {
    const row = this.lastClickedAssignment;
    if (!row || !this.assignmentEditLockReason(row)) return;
    if (this.assignmentsReadOnly) this.commonService.showPermissionNotification();
    else if (this.assignmentDetailsGrid?.isEdit) this.commonService.showNotification('warning', 'Transactions grid is in edit mode! ');
  }

  // The row opened for editing: the Reference Activity list leaves out the activities the other assignments use,
  // as before (and only billable ones for Kingslynn).
  onAssignmentEditStart(row: any) {
    const others = this.assignments
      .filter(a => !a.isDeleted && a.referenceActivityCode !== row.referenceActivityCode)
      .map(a => a.referenceActivityCode);
    let list = this.updateRefActivityDS(others);
    if (this.USER.company === Companies.kingslynn) {
      list = list.filter(ref => ref.category === 'Billable Service');
    }
    this.refActivityOptions = list.map(ref => ({ value: ref.value, label: ref.description }));
    this.assignmentEditStartedAt = new Date();
  }

  // A picked Reference Activity fills Service Type. When the assignment has transactions the user is asked first,
  // and on yes they are deleted at once, as before.
  onRefActivityPicked(code: any, ctx: any) {
    const item = this.referenceActivities.find(ref => ref.value === code);
    if (!item) return;
    const apply = () => {
      ctx.setValue(item.description);
      ctx.setRawCell('referenceActivityCode', item.value);
      ctx.setRawCell('serviceTypeCode', item.serviceTypeCode);
      ctx.setRawCell('serviceTypeDescription', item.serviceTypeDescription);
      ctx.setRawCell('category', item.category);
    };
    // A new row has no tempId yet, so it has no transactions.
    if (ctx.row?.tempId != null && this.hasTransaction(ctx.row)) {
      this.commonService.showConfirmation('Are you sure? The transactions added for this assignment will be deleted').then(res => {
        if (res.isConfirmed) {
          apply();
          this.deleteAssignmentDetailsByAssignment(ctx.row);
        } else {
          // Put the old value back: the dropdown is drawn again from the row's unchanged code.
          this.refActivityEditorShown = false;
          setTimeout(() => this.refActivityEditorShown = true);
        }
      });
    } else {
      apply();
    }
  }

  onListPicked(list: any[], textField: string, codeColumn: string, value: any, ctx: any) {
    const item = list?.find(i => i.value === value);
    ctx.setValue(item?.[textField] ?? '');
    ctx.setRawCell(codeColumn, value);
  }

  // Enter, the ✓ icon or the popup's Save: the edited values go back into this.assignments (a new row is added).
  onAssignmentCommit(commit: GridRowCommitEvent) {
    const r: any = commit.row;
    const target = commit.isDraft ? this.setAssignmentRow({}) : this.assignments.find(a => a.rowId === r.rowId);
    if (!target) return;
    for (const field of ['referenceActivityCode', 'referenceActivityDescription', 'serviceTypeCode', 'serviceTypeDescription',
      'reportedProblem', 'reportedProblemDescription', 'description', 'solutionCode', 'solutionDescription', 'priority',
      'startDate', 'endDate', 'category']) {
      if (field in r) target[field] = r[field] === '' && (field === 'startDate' || field === 'endDate') ? null : r[field];
    }
    // As before: while Start Date is hidden, an assignment starts at check-in.
    if (this.assignmentsGrid?.captureState().columnVisibility?.['startDate'] !== true) {
      target.startDate = this.checkinTime ? new Date(this.checkinTime) : null;
    }
    if (commit.isDraft) this.assignments.push(target);
    this.assignmentEditing = false;
    this.calculateAmounts(false);
    this.isTabValid = true;
    this.refreshGrids();
  }

  onAssignmentRevert() {
    this.assignmentEditing = false;
  }

  onAssignmentsToolbarAction(event: { key: string }) {
    if (event.key !== ADD_ASSIGNMENT_ACTION || this.isAddAssignmentDisabled) return;
    if (this.assignmentEditing) {
      this.commonService.showNotification('warning', 'There is a row in assignment grid, which is already in edit mode!', 'center', 5000);
    } else if (this.assignmentsReadOnly) {
      this.commonService.showPermissionNotification();
    } else {
      this.assignmentDetailsGrid.endEdit();
      if (this.assignmentDetailsGrid.isEdit) {
        this.commonService.showNotification('warning', 'Can not add assignment if trasaction is being edited!', 'center', 5000);
      } else {
        // An empty new row, open for editing; it joins this.assignments when it is saved.
        this.assignmentsGrid.startDraft();
      }
    }
  }

  onAssignmentActionIconClick(event: GridActionIconClickEvent) {
    const row: any = this.assignments.find(a => a.rowId === event.row['rowId']);
    if (!row) return;
    const locked = this.assignmentActionLockReason(row);
    if (locked) {
      this.commonService.showNotification('info', locked);
    } else if (this.assignmentsReadOnly) {
      this.commonService.showPermissionNotification();
    } else if (event.iconKey === 'delete') {
      this.deleteAssignment(row);
    } else if (!this.assignmentDetailsGrid.isEdit && !this.assignmentEditing) {
      row['callGroup'] = this.data.callGroup;
      this.openEditAssignmentPopup(row);
    } else {
      this.commonService.showNotification('warning', 'Assignment or Transaction is in edit mode!');
    }
  }


  // ---- Transactions on @inavista/components ---------------------------------------------------------------------
  // The rows are this.assignmentDetails (LocalRowsGridApi, no endpoint). The column list stays assignmentDetailGrid
  // and every column's `edit` is drawn in its cell with @inavista/components controls (CellEditorHost), so the editors and every rule in
  // them run as before. this.assignmentDetailsGrid is a stand-in with the members the old code used on the
  // Syncfusion grid (isEdit, dataSource, getColumnByField, refresh, endEdit...), so that code runs unchanged.

  private createTransactionsGridShim(): any {
    const self = this;
    const column = (field: string) => {
      const c = self.assignmentDetailGrid?.columns?.find(col => col.field === field);
      if (!c) return { visible: false, validationRules: {} };
      return {
        get validationRules() { return c.validationRules ?? (c.validationRules = {}); },
        set validationRules(rules) { c.validationRules = rules; },
        get visible() { return self.isTransactionColumnVisible(field); },
        set visible(visible: boolean) {
          const changed = (c.visible !== false) !== visible;
          c.visible = visible;
          // A code-set column (Estimated Qty, by the order's mode): the grid is configured again, so the user's layout
          // is not touched. Other columns follow the user's layout.
          if (changed && c.showInColumnChooser === false) self.reconfigureTransactionsGrid();
          else if (c.showInColumnChooser !== false) self.setTransactionColumnVisible(field, visible);
        },
      };
    };
    return {
      get isEdit() { return self.transactionEditing; },
      get dataSource() { return self.assignmentDetails; },
      set dataSource(rows) { self.assignmentDetails = rows; },
      get columns() { return self.assignmentDetailGrid?.columns ?? []; },
      allowSorting: true, allowReordering: true, allowFiltering: true,
      getColumnByField: column,
      refresh: () => self.refreshTransactionsGrid(),
      refreshColumns: () => self.refreshTransactionsGrid(),
      // Leaving the open row saves it, as endEdit did.
      endEdit: () => self.transactionsGrid?.saveBatch(),
    };
  }

  // After initAssignmentDetailsGrid: the editor templates are drawn for txEditFields, then the grid is configured.
  setupTransactionsGrid() {
    const { hosted, builtIn } = transactionEditFields(this.assignmentDetailGrid.columns);
    this.txBuiltInEditFields = builtIn;
    this.txEditFields = hosted;
    setTimeout(() => {
      const templates = this.txEditorTemplates.toArray();
      const ctx: TransactionsGridContext = {
        persistenceKey: TRANSACTIONS_PERSISTENCE_KEY,
        commands: TRANSACTION_COMMANDS,
        materialCostType: CostTypes.material,
        columns: this.assignmentDetailGrid.columns,
        editors: Object.fromEntries(this.txEditFields.map((field, i) => [field, templates[i]])),
        editLockReason: () => this.transactionEditLockReason(),
        actionLockReason: () => this.isEditable ? null : 'Transactions can be changed while the order is In Progress.',
        addDisabledReason: () => this.isAddTransactionDisabled ? 'Transactions can be added while the order is In Progress.' : null,
        validate: row => this.validateTransaction(row),
      };
      this.txSchema = LocalRowsGridApi.schema([
        ...transactionFields(this.assignmentDetailGrid.columns).map(c => [c.field, c.type === 'number' ? 'decimal' : c.type === 'date' ? 'datetime' : 'nvarchar'] as [string, string]),
        [TRANSACTION_OPEN_FIELD, 'nvarchar'],
      ]);
      this.txContext = ctx;
      this.transactionsConfig = buildTransactionsGridConfig(ctx);
      this.transactionsActionIcons = buildTransactionsActionIcons(ctx);
      this.refreshTransactionsGrid();
    });
  }

  // The column list changed (a code-set column shown or hidden, e.g. Estimated Qty by the order's mode).
  reconfigureTransactionsGrid() {
    if (!this.txContext) return;
    const { hosted, builtIn } = transactionEditFields(this.assignmentDetailGrid.columns);
    this.txBuiltInEditFields = builtIn;
    this.txEditFields = hosted;
    // The grid reads its hidden / always-shown columns when it is created: it is drawn again with the new list.
    this.transactionsConfig = null;
    setTimeout(() => {
      const templates = this.txEditorTemplates.toArray();
      this.txContext = { ...this.txContext, editors: Object.fromEntries(this.txEditFields.map((f, i) => [f, templates[i]])) };
      this.transactionsConfig = buildTransactionsGridConfig(this.txContext);
      setTimeout(() => {
        this.refreshTransactionsGrid();
        // A layout saved while Estimated Qty was hidden puts it last: back before Quantity, as in the old grid.
        setTimeout(() => this.placeEstimatedQty(), 500);
      });
    });
  }

  private placeEstimatedQty() {
    const state = this.transactionsGrid?.captureState();
    const order = state?.columnOrder;
    if (!order || !this.isTransactionColumnVisible('estimateQty')) return;
    const rest = order.filter(c => c !== 'estimateQty');
    const at = rest.indexOf('qty');
    if (at < 0 || order.indexOf('estimateQty') === at) return;
    rest.splice(at, 0, 'estimateQty');
    this.transactionsGrid.applyState({ ...state, columnOrder: rest });
  }

  /** The column's `edit`, read at draw time: ngOnChanges can replace a column (the Reference Activity one). */
  txEditDef(field: string) {
    return this.assignmentDetailGrid?.columns?.find(c => c.field === field)?.edit;
  }

  // The rows the grid shows: the transactions not deleted, each foreign-key column with its list's text, as the
  // Syncfusion foreign-key columns showed it (costTypeCode keeps the code for the Parts Order rule).
  refreshTransactionsGrid() {
    if (!this.transactionsConfig) return;
    const columns = this.assignmentDetailGrid.columns;
    const fk = columns.filter(c => c.foreignKeyField && c.foreignKeyValue && c.dataSource);
    const rows = this.assignmentDetails.filter(d => !d.isDeleted).map(d => {
      const row = { ...d, costTypeCode: d.costType };
      for (const c of fk) {
        const item = (c.dataSource as any[]).find(x => x[c.foreignKeyField] === d[c.field]);
        if (item) row[c.field] = item[c.foreignKeyValue];
      }
      return row;
    });
    this.transactionsRows.set(TRANSACTIONS_URL, this.txSchema, rows);
    this.transactionsGrid?.refresh();
  }

  /** The transaction a grid row stands for: the page's own object (a new row: the one Add built). */
  transactionRowFor(row: any) {
    return row?.rowId == null ? this.pendingNewTransaction : this.assignmentDetails.find(d => d.rowId === row.rowId);
  }

  isTransactionColumnVisible(field: string): boolean {
    const own = this.assignmentDetailGrid?.columns?.find(col => col.field === field);
    // A column kept out of the chooser is shown or hidden by the code alone (Estimated Qty).
    if (own?.showInColumnChooser === false) return own.visible !== false;
    const visibility = this.transactionsGrid?.captureState().columnVisibility;
    if (visibility && field in visibility) return visibility[field];
    const c = this.assignmentDetailGrid?.columns?.find(col => col.field === field);
    return !!c && c.visible !== false;
  }

  setTransactionColumnVisible(field: string, visible: boolean) {
    if (!this.transactionsGrid) return;
    const state = this.transactionsGrid.captureState();
    this.transactionsGrid.applyState({ ...state, columnVisibility: { ...(state.columnVisibility ?? {}), [field]: visible } });
  }

  // The Syncfusion validation the old grid ran on save: each shown column's rules on its editor's value.
  validateTransaction(row: any): GridRowProblem | null {
    for (const c of this.assignmentDetailGrid.columns) {
      const rules = c.validationRules;
      if (!rules || !this.isTransactionColumnVisible(c.field)) continue;
      const open = this.txOpenEditors.get(c.field);
      if (!open && !this.txBuiltInEditFields.includes(c.field)) continue;
      const value = open ? open.read() : row[c.field];
      const required = Array.isArray(rules.required) ? rules.required[0] : rules.required;
      if (required && (value === null || value === undefined || value === '')) {
        return { column: c.field, message: `${c.headerText}: This field is required.` };
      }
      for (const [rule, fails] of [['max', (v, n) => +v > +n], ['min', (v, n) => +v < +n]] as [string, (v: any, n: any) => boolean][]) {
        if (rules[rule] == null || value === null || value === undefined || value === '') continue;
        const [limit, message] = Array.isArray(rules[rule]) ? rules[rule] : [rules[rule]];
        if (fails(value, limit)) {
          return { column: c.field, message: message ?? `${c.headerText}: Please enter a value ${rule === 'max' ? 'less' : 'greater'} than or equal to ${limit}.` };
        }
      }
    }
    return null;
  }

  // Why a transaction can't be opened (the old allowEditing and beginEdit cancels), or null.
  transactionEditLockReason(): string | null {
    if (!this.isEditable) return 'Transactions can be changed while the order is In Progress.';
    if (this.transactionsReadOnly) return 'You do not have permission to change transactions.';
    if (this.assignmentEditing) return 'Assignment is in edit mode!';
    return null;
  }

  // A double click on a locked row says why, as the old beginEdit did.
  onTransactionDoubleClick() {
    if (!this.lastClickedTransaction || !this.isEditable) return;
    if (this.transactionsReadOnly) this.commonService.showPermissionNotification();
    else if (this.assignmentEditing) this.commonService.showNotification('warning', 'Assignment is in edit mode! ');
  }

  // The row opened: the old actionBegin('beginEdit'), the editors draw, then the old actionComplete('beginEdit').
  onTransactionEditStart(event: GridRowEditStartEvent) {
    const rowData = this.transactionRowFor(event.row);
    if (!rowData) return;
    this.transactionEditing = true;
    this.onAssignmentDetailsActionBegin({ requestType: 'beginEdit', rowData });
    this.txHiddenEditFields = transactionFields(this.assignmentDetailGrid.columns)
      .filter(c => c.edit && !this.isTransactionColumnVisible(c.field))
      .map(c => c.field);
    this.txHiddenRow = rowData;
    // Leaving the row always saves it, as the Syncfusion grid did: the row counts as changed from the start, so
    // closing it always says so (commit or revert) and transactionEditing can't stay set.
    const marked = this.transactionsGrid?.setDraftValue(TRANSACTION_OPEN_FIELD, String(Date.now()));
    setTimeout(() => {
      if (!marked) this.transactionsGrid?.setDraftValue(TRANSACTION_OPEN_FIELD, String(Date.now()));
      this.onTransactionGridActionComplete({ requestType: 'beginEdit', rowData }, this.assignmentDetailsGrid);
    });
  }

  // Enter, the ✓ icon, a click elsewhere or the popup's Save: every open editor's value goes into the row, as the
  // Syncfusion grid did, then the old actionComplete('save').
  onTransactionCommit(commit: GridRowCommitEvent) {
    const target = this.transactionRowFor(commit.row);
    if (!target) return;
    for (const field of this.txBuiltInEditFields) {
      if (field in commit.row) target[field] = commit.row[field];
    }
    for (const [field, edit] of this.txOpenEditors) target[field] = edit.read();
    this.txHiddenRow = null;
    if (commit.isDraft) this.assignmentDetails.push(target);
    this.pendingNewTransaction = null;
    this.transactionEditing = false;
    this.onTransactionGridActionComplete({ requestType: 'save', data: target }, this.assignmentDetailsGrid);
    this.refreshTransactionsGrid();
  }

  // Esc or ✕: as the old actionComplete('cancel'). A new row was never added to the list.
  onTransactionRevert(event: { row: any; isDraft: boolean }) {
    this.transactionEditing = false;
    this.txHiddenRow = null;
    if (event.isDraft) {
      this.pendingNewTransaction = null;
      this.resetTempValuesForTransaction();
      return;
    }
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.onTransactionGridActionComplete({ requestType: 'cancel', rowData, data: rowData }, this.assignmentDetailsGrid);
  }

  onTransactionsToolbarAction(event: { key: string }) {
    if (event.key === ADD_TRANSACTION_ACTION) {
      this.onAssignmentDetailsToolbarClick({ item: { id: 'add-new-assignment-detail' } } as any, this.assignmentDetailsGrid);
    }
  }

  // The old command column: disabled while the order is not In Progress, then the same handler as before.
  onTransactionActionIconClick(event: GridActionIconClickEvent) {
    if (!this.isEditable) return;
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.onAssignmentDetailsCommandClick({ commandColumn: { title: event.iconKey }, rowData });
  }

  // Item and Description open the item, as before.
  onTransactionHyperlink(event: GridHyperlinkClickEvent) {
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.showMasterItemCodePopup(rowData);
  }

  setTempValuesForTransaction(data) {
    // this.assignmentId = +data.tempId;
    this.assignmentDetailId = +data.assignmentDetailId;
    this.activityId = data.activityId;
    this.assignmentDetailReferenceActivityDescription = data.referenceActivityDescription;
    this.assignmentDetailReferenceActivityCode = data.referenceActivityCode
    this.assignmentDetailServiceTypeCode = data.serviceTypeCode;
  }

  onAssignmentDetailsActionBegin(args) {
    if (args.requestType === 'beginEdit') {
      this.taxAmount = 0;
      this.getPriceForItem = false;
      this.serviceItemGroup = args.rowData.serviceItemGroup;
      this.rowServiceItemGroup = args.rowData.serviceItemGroup;
      this.tempUnit = this.getUnit(args.rowData.costType);
      if (args.rowData.costType === CostTypes.material || args.rowData.costType === CostTypes.otherCost) {
        if (this.skipBeginEditEvent) {
          this.skipBeginEditEvent = false;
        }
        this.getItemList(args.rowData);

      }
      this.setItemCodeValidation(args.rowData.costType);
      if (this.assignmentEditing) {
        args.cancel = true;
        this.commonService.showNotification('warning', 'Assignment is in edit mode! ');
      } else {
        if (args.rowData && args.rowData.costType === 'Material') {
          !this.isIsc && !this.isIscManager && this.data.mode === 'Actual' && this.checkOnHandQuantity(args.rowData.itemCode, args.rowData.qty, args.rowData.issuedQty, args.rowData);
          this.mandatoryItem = true;
        } else {
          this.assignmentDetailsGrid.getColumnByField('qty').validationRules = { required: true };
          this.mandatoryItem = false;
        }
      }
      if (this.transactionsReadOnly) {
        args.cancel = true;
        this.commonService.showPermissionNotification();
      }
      this.setTempValuesForTransaction(args.rowData);
    } else if (args.requestType === 'delete') {
      args.cancel = true;
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else if (this.isEditable) {
        this.deleteTransaction(args.data[0]);
      }
    }
  }

  setAssignmentRow(assignment) {
    const currentTime = this.checkinTime ? new Date(this.checkinTime) : null;
    const rowId = this.getMaxRowId(this.assignments) + 1;
    assignment.rowId = rowId;
    assignment.assignmentId = 0;
    assignment.activityId = rowId * 10;
    assignment.tempId = this.getTempId();
    assignment.description = "";
    assignment.serviceTypeCode = "";
    assignment.serviceTypeDescription = "";
    assignment.referenceActivityCode = "";
    assignment.referenceActivityDescription = "";
    assignment.reportedProblem = "";
    assignment.reportedProblemDescription = "";
    assignment.solutionCode = "";
    assignment.solutionDescription = "";
    assignment.priority = this.priorities?.find(priority => priority.text === 'Manual Action' || priority.text === 'Low')?.value;
    assignment.startDate = currentTime;
    assignment.endDate = null;
    assignment.isDeleted = false;
    return assignment;
  }

  getTempId() {
    const assignments = this.assignments.filter(assignment => !assignment.isDeleted);
    if (assignments.length) {
      let tempId = 1;
      assignments.forEach(assignment => { // sqltodo
        if (!isNaN(assignment.tempId) && +assignment.tempId > +tempId) {
          tempId = +assignment.tempId;
        }
      });
      return tempId + 1;
    } else {
      return 1;
    }
  }

  initAssignmentDetailsGrid() {
    const laborFieldHeader = this.USER.company === Companies.kingslynn ? 'Labour Type' : 'Labor Type';
    this.assignmentDetailGrid = {
      toolbar: [],
      filterSettings: { type: 'Menu' },
      columns: [
        { field: 'rowId', type: 'number', isPrimaryKey: true, showInColumnChooser: false, visible: false },
        { field: 'assignmentDetailId', headerText: 'ID', width: 140, textAlign: 'Left', visible: false, showInColumnChooser: false },
        {
          field: 'assignmentId', headerText: 'Reference Activity', width: 148, filter: { type: 'Excel' }, textAlign: 'Left', validationRules: { required: true },
          foreignKeyValue: 'referenceActivityDescription', foreignKeyField: 'tempId', showInColumnChooser: false, dataSource: this.assignments, edit: this.editAssignment()
        },
        { field: 'referenceActivityCode', headerText: 'Reference Activity', width: 184, filter: { type: 'Excel' }, textAlign: 'Left', visible: false, showInColumnChooser: false, validationRules: { required: true } },
        { field: 'referenceActivityDescription', headerText: 'Term Description', clipMode: 'EllipsisWithTooltip', visible: false, showInColumnChooser: false },
        {
          field: 'costType', headerText: 'Cost Type', width: 137, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false,
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.costTypes, edit: this.editCostType(), validationRules: { required: true }
        },
        { field: 'itemCode', headerText: 'Item', width: 175, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false, edit: this.editItem(), validationRules: { required: true } },
        { field: 'itemDescription', headerText: 'Description', width: 195, type: 'string', textAlign: 'Left', edit: this.editItemDescription(), showInColumnChooser: false },
        { field: 'estimateQty', headerText: 'Estimated Qty', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, width: 150, format: 'n2', showInColumnChooser: false, visible: this.data.mode === ModeList.actual && this.data.estimateApproved, type: 'number', allowEditing: false },
        { field: 'qty', headerText: 'Quantity', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, type: 'number', showInColumnChooser: false, width: 150, format: 'n2', step: 0.1, decimals: 2, validateDecimalOnType: true, edit: this.editQuantity(), validationRules: { required: true } },
        { field: 'price', headerText: 'Price', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, type: 'number', showInColumnChooser: false, width: 130, format: 'n2', edit: this.editPrice(), validationRules: { required: true } },
        { field: 'discountAmount', headerText: 'Discount Amount', type: 'number', width: 180, showInColumnChooser: false, textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, format: 'n2', edit: this.editDiscountAmount() },
        { field: 'warrantyCoverage', headerText: 'Warranty Amount', type: 'number', width: 180, format: 'n2', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, allowEditing: false, visible: false, edit: this.editWarrantyAmount() },
        { field: 'contractCoverage', headerText: 'Contract Amount', type: 'number', width: 180, format: 'n2', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, allowEditing: false, visible: false, edit: this.editContractAmount() },
        { field: 'totalAmount', headerText: 'Total Amount', width: 180, type: 'number', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, showInColumnChooser: false, format: 'n2', edit: this.editTotalAmount() },
        {
          field: 'unit', headerText: 'Unit', textAlign: 'Left', type: 'string', width: 150, visible: false, filter: { type: 'Excel' },
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.units, edit: this.editUnit()
        },
        { field: 'laborType', headerText: laborFieldHeader, width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editLaborType(), visible: false, filter: { type: 'Excel' }, },
        { field: 'warehouse', headerText: 'Warehouse', width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editTransactionWarehouse(), visible: false, filter: { type: 'Excel' }, },
        {
          field: 'returnReasonCode', headerText: 'Return Reason', width: 150, type: 'string', textAlign: 'Left',
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.returnReasons, edit: this.editReturnReason(), visible: false, showInColumnChooser: false
        },
        { field: 'task', headerText: 'Task', type: 'string', width: 145, textAlign: 'Left', edit: this.editTask(), visible: false, filter: { type: 'Excel' }, },
        { field: 'startDate', headerText: 'Start Time', type: 'date', textAlign: 'Left', format: { type: 'date', format: 'd MMM, y h:mm a' }, width: 250, edit: this.editStartTime(), visible: false },
        { field: 'endDate', headerText: 'End Time', type: 'date', textAlign: 'Left', format: { type: 'date', format: 'd MMM, y h:mm a' }, width: 250, edit: this.editEndTime(), visible: false },

        { field: 'costComponent', headerText: 'Cost Component', width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editCostComponent(), visible: false, filter: { type: 'Excel' }, },
        { field: 'taxpercent', headerText: 'Tax %', width: 160, format: 'n3', type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editTaxPercent(), visible: false },
        { field: 'taxAmount', headerText: 'Tax Amount', width: 180, format: 'n3', type: 'string', textAlign: 'Right', headerTextAlign: 'Right', customAttributes: { class: 'right-align' }, allowEditing: false, edit: this.editTax(), visible: false, filter: { type: 'Excel' }, },
        { field: 'customerCurrency', headerText: 'Currency', type: 'string', width: 160, textAlign: 'Left', allowEditing: false, visible: false, filter: { type: 'Excel' }, },

        {
          field: 'Actions', headerText: 'Actions', showInColumnChooser: false, textAlign: 'Center', width: 140, allowFiltering: false, allowSorting: false,
          commands: [
            {
              title: 'Create Parts Order',
              type: 'Edit',
              buttonOption: {
                iconCss: `e-btn-icon fas fa-cubes e-icons`,
                cssClass: `e-flat action-button`
              }
            },
            {
              title: 'Edit Assignment Detail',
              type: 'Edit',
              buttonOption: {
                iconCss: `fas fa-pencil-alt`,
                cssClass: `e-flat action-button`
              }
            },
            {
              title: 'Delete Detail',
              type: 'Delete',
              buttonOption: {
                iconCss: `fas fa-trash`,
                cssClass: `e-flat action-button`
              }
            },
            // Shown only while the row is edited: lets touch screens save or cancel without Enter/Escape.
            { title: 'Save', type: 'Save', buttonOption: { iconCss: `fas fa-check`, cssClass: `e-flat action-button` } },
            { title: 'Cancel', type: 'Cancel', buttonOption: { iconCss: `fas fa-times`, cssClass: `e-flat action-button` } },
          ]
        }
      ]
    };

    if (this.USER.company === Companies.kingslynn) {
      const commentIndex = this.assignmentDetailGrid.columns.findIndex(col => col.field === 'discountAmount') + 1;
      this.assignmentDetailGrid.columns.splice(commentIndex, 0, { field: 'comments', headerText: 'Comments', width: 150, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false, allowEditing: true, visible: true, validationRules: { required: false } });
    } else {
      const commentIndex = this.assignmentDetailGrid.columns.findIndex(col => col.field === 'costType') + 1;
      this.assignmentDetailGrid.columns.splice(commentIndex, 0, { field: 'comments', headerText: 'Comments', width: 150, textAlign: 'Left', filter: { type: 'Excel' }, allowEditing: true, visible: false, validationRules: { required: false } });
    }

    const commentIndex = this.assignmentDetailGrid.columns.findIndex(detail => detail.field === 'comments');
    if (this.isIsc || this.isIscManager) {
      const commentsColumn = (this.assignmentDetailGrid.columns as any)?.find(col => col.field === 'comments');
      commentsColumn.visible = true;
      commentsColumn.showInColumnChooser = false;
      const subCostType = {
        field: 'subCostType', headerText: 'Subcost Type', width: 137, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false,
        foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: SubCostTypeList, edit: this.editSubCostType()
      }
      this.assignmentDetailGrid.columns.splice(commentIndex, 0, subCostType);
    }
  }

  getMaxRowId(datasource) {
    if (datasource.length) {
      return Math.max.apply(Math, datasource.map(row => row.rowId)) || 0;
    } else {
      return 0;
    }
  }

  setAssignmentDetailRow(detail) {
    let costType = this.USER.company === Companies.kingslynn ?
      this.costTypes.find(type => type.value === CostTypes.otherCost)
      : this.costTypes.find(type => type.value === CostTypes.material);
    const currentTime = this.checkinTime ? new Date(this.checkinTime) : null;
    detail.rowId = this.getMaxRowId(this.assignmentDetailsGrid.dataSource) + 1;
    detail.assignmentId = '';
    detail.assignmentDetailId = '';
    detail.activityId = null;
    detail.comments = '';
    detail.referenceActivityDescription = '';
    detail.referenceActivityCode = '';
    detail.serviceTypeCode = '';
    detail.serviceTypeDescription = '';
    detail.costType = costType ? costType.value : this.costTypes[0]?.value || '';
    detail.subCostType = '';
    detail.itemCode = null;
    detail.itemDescription = this.getItemDescription(detail.costType);
    detail.customerCurrency = this.customerCurrency;
    detail.qty = 1;
    detail.price = detail.costType === CostTypes.labor ? this.laborRate : 0;
    detail.totalAmount = 0;
    detail.unit = this.getUnit(detail.costType);
    this.unitCode = detail.unit;
    detail.startDate = currentTime;
    this.assignmentDetailStartTimeValue = currentTime;
    detail.endDate = null;
    detail.task = this.getTask(detail.costType);
    detail.laborType = this.getLaborType(detail.costType);
    detail.warehouse = this.getWarehouse(detail.costType);
    detail.costComponent = this.getCostComponent(detail.costType);
    detail.discountAmount = 0;
    detail.warrantyCoverage = 0;
    detail.contractCoverage = 0;
    detail.taxpercent = this.getTaxRate(detail.costType);
    detail.taxAmount = 0;
    detail.returnReasonCode = null;
    detail.serviceItem = null;
    detail.isDeleted = false;
    detail.warehouse = this.data?.technicianWarehouse;
    return detail;
  }

  showEstimatedQtyCol(showColumn) {
    this.assignmentDetailsGrid.getColumnByField('estimateQty').visible = showColumn;
  }

  getItemDescription(costType, costTypeChanged = false) {
    if (costType === CostTypes.labor) {
      return "Labor charge";
    } else if (costType === CostTypes.material || !costType) {
      return null;
    } else if (costType === CostTypes.other) {
      return "Travel call-out charge";
    } else if (costType === CostTypes.otherCost) {
      return costTypeChanged ? null : this.itemDescriptionObject && this.itemDescriptionObject && this.itemDescriptionObject.value ? this.itemDescriptionObject.value : null;
    }
  }

  getTaxRate(costType) {
    if (this.taxRates) {
      const laborTypeKeys = {
        [CostTypes.labor]: 'LABMOBILE',
        [CostTypes.material]: 'MATERIAL',
        [CostTypes.other]: 'TRAVEL',
        [CostTypes.otherCost]: 'OTHER'
      }
      let taxRateItem = this.taxRates.find(taxRate => taxRate.productCategory === laborTypeKeys[costType]);
      if (taxRateItem && taxRateItem.taxRatePercentage) {
        return taxRateItem.taxRatePercentage;
      } else {
        return 0
      }
    } else {
      return 0;
    }
  }

  getCostComponent(costType: string) {
    if (costType === CostTypes.labor) {
      return this.commonService.userDefaults && this.commonService.userDefaults.lbrCCMP ? this.commonService.userDefaults.lbrCCMP : null;
    } else if (costType === CostTypes.material) {
      return this.commonService.userDefaults && this.commonService.userDefaults.mtlCCMP ? this.commonService.userDefaults.mtlCCMP : null;
    } else if (costType === CostTypes.other || costType === CostTypes.otherCost) {
      return this.USER.company === Companies.kingslynn ?
        this.commonService.userDefaults && this.commonService.userDefaults.othCCMP ? this.commonService.userDefaults.othCCMP : null
        : this.commonService.userDefaults && this.commonService.userDefaults.traCallCCMP ? this.commonService.userDefaults.traCallCCMP : null;
    }
  }

  getWarehouse(costType: string) {
    if (costType === CostTypes.material) {
      return this.warehouse;
    } else {
      return null;
    }
  }

  getLaborType(costType: string) {
    if (costType === CostTypes.labor) {
      return this.commonService.userDefaults && this.commonService.userDefaults.lbrCHLT ? this.commonService.userDefaults.lbrCHLT : null;
    } else {
      return null;
    }
  }

  getWarrantyAmount(row?) { //row: if called from calculateAmounts()
    if (row) {
      return row.warrantyCoverage;
    } else {
      let warrantyPercent = 0, warrantyCoverageIndex;
      let costType = this.costTypeObject?.value && (this.costTypeObject?.value as string)?.toLowerCase(); // travel
      if (this.costTypeObject && this.costTypeObject.value === CostTypes.other) {
        costType = 'travel';
      }
      if (this.costTypeObject && this.costTypeObject.value === CostTypes.otherCost) {
        costType = 'other'; // for kingslynn contract and warranty, we will get 'other' in the API getContractAndWarranty
      }
      warrantyCoverageIndex = this.equipmentInfoData?.warrantyDescriptionObj?.findIndex(war => war.costType.toLowerCase() === costType || war.costType === 'all');
      if (warrantyCoverageIndex > -1) {
        warrantyPercent = this.equipmentInfoData.warrantyDescriptionObj[warrantyCoverageIndex].percentageCoverage;
      }
      let totalPrice = (this.quantityObject.value * this.priceObject.value) - this.discountAmountObject.value;
      return totalPrice > 0 ? +(totalPrice * warrantyPercent / 100)?.toFixed(2) : 0;
    }
  }

  getContractAmount(row?) { //row: if called from calculateAmounts()
    if (row) {
      return row.contractCoverage;
    } else {
      let contractPercent = 0, contractCoverageIndex;
      let costType = this.costTypeObject.value && (this.costTypeObject.value as string).toLowerCase();
      if (this.costTypeObject && this.costTypeObject.value === CostTypes.other) {
        costType = 'travel';
      }
      if (this.costTypeObject && this.costTypeObject.value === CostTypes.otherCost) {
        costType = 'other'; // for kingslynn contract and warranty, we will get 'other' in the API getContractAndWarranty
      }
      contractCoverageIndex = this.equipmentInfoData?.serviceContractDescriptionObj?.findIndex(contract => contract.costType.toLowerCase() === costType || contract.costType === 'all');
      if (contractCoverageIndex > -1) {
        contractPercent = this.equipmentInfoData?.serviceContractDescriptionObj[contractCoverageIndex].percentageCoverage;
      }

      let totalPrice = (this.quantityObject.value * this.priceObject.value) - this.discountAmountObject.value;
      return totalPrice > 0 ? +(totalPrice * contractPercent / 100)?.toFixed(2) : 0;
    }
  }

  getUnit(costType: string) {
    if (costType === CostTypes.labor) {
      return this.units.find(unit => unit.description === 'Hours').value;
    } else if (costType === CostTypes.material || costType === CostTypes.other || costType === CostTypes.otherCost) {
      const unit = this.units.find(unit => unit.description === 'Each');
      return unit ? unit.value : this.units[0].value;
    } else {
      return null;
    }
  }

  getTask(costType: string) {
    if (costType === CostTypes.labor) {
      return this.commonService.userDefaults && this.commonService.userDefaults.lbrCTSK ? this.commonService.userDefaults.lbrCTSK : null;
    } else {
      return null;
    }
  }

  openEditAssignmentPopup(rowData) {
    this.selectedAssignment = rowData;
    this.showAssignmentsPopup = true;
  }

  addAssignmentDetail() {
    // Built as before (defaults, warehouse, unit...). It joins this.assignmentDetails when the row is saved.
    this.pendingNewTransaction = this.setAssignmentDetailRow({});
    this.serviceOrderService.hasTransaction.next(true);
    const onlyOneAssignment = this.assignments.filter(x => !x.isDeleted).length === 1;
    this.defaultReferenceActivity = onlyOneAssignment && this.assignments.find(x => !x.isDeleted) || null;
    this.transactionsGrid?.startDraft();
  }

  onAssignmentDetailsToolbarClick(args: ToolbarClickEventArgs, grid: any) {
    if (args.item.id === 'add-new-assignment-detail') {
      if (this.isAddTransactionDisabled) { return; } // the button is greyed out
      this.assignmentDetailsGrid.endEdit();
      if (!this.assignmentDetailsGrid.isEdit) {
        if (this.assignments && this.assignments.length) {
          if (this.transactionsReadOnly) {
            this.commonService.showPermissionNotification();
          } else {
            this.assignmentsGrid?.saveBatch();
            if (!this.assignmentEditing) {
              this.addAssignmentDetail();
            }
          }
        } else {
          this.commonService.showNotification('warning', 'Please add an assignment first to add transaction!', 'center', 5000);
        }
      } else {
        this.commonService.showNotification('warning', 'There is a row in transaction grid, which is already in edit mode!', 'center', 5000);
      }
    }
  }

  onAssignmentDetailsCommandClick(args: any) {
    if (args.commandColumn.title === 'Create Parts Order') {
      this.commonService.getItems(args.rowData.itemCode, 30, this.USER.company)
        .subscribe((res: ApiResponse) => {
          if (res.isSuccessful) {
            if (this.isIsc || this.isIscManager) {
              this.fromExecutionTab = [args.rowData];
              if (res?.result[0]?.status === PartsAvailabilityStatus.inActive) {
                this.commonService.showNotification('warning', '\nItem ' + res?.result[0]?.item + res?.result[0]?.itemDescription + ' is obsolete');
              } else {
                this.showCartCheckoutPopup = true;
              }
            }
            else {
              if (res?.result[0]?.status === PartsAvailabilityStatus.inActive) {
                this.commonService.showNotification('error', '\nItem ' + res?.result[0]?.item + '-' + res?.result[0]?.itemDescription + ' is obsolete');
                if (res?.result[0]?.alternateItem !== null) {
                  this.commonService.showConfirmation('\nItem ' + res?.result[0]?.item + '-' + res?.result[0]?.itemDescription + ' is obsolete.' + '\n\n Would you like to add the alternate item ' + res?.result[0]?.alternateItem)
                    .then(result => {
                      if (result.isConfirmed) {
                        // this.commonService.getItems(res?.result[0]?.alternateItem, 30, this.USER.company)
                        this.commonService.getAlternateItemData(res?.result[0]?.alternateItem)
                          .subscribe((res2: ApiResponse) => {
                            this.showPartsOrderPopup.emit({
                              update: false,
                              itemCode: res2?.result?.item,
                              itemDescription: res2?.result?.itemDescription,
                              itemGroup: res2?.result?.itemGroup,
                              serviceItemGroup: res2?.result?.serviceItemGroup,
                              serviceOrderId: this.data.serviceOrderId,
                              warehouse: args.rowData.warehouse
                            });
                          })
                      }
                      else {
                        return;
                      }
                    })
                }
                else { // if item is obsolete but alternateItem is null 
                  this.commonService.showNotification('error', '\nItem ' + res?.result[0]?.item + '-' + res?.result[0]?.itemDescription + ' is obsolete');
                  args.cancel = true;
                  return;
                }
              } else {
                if (this.data.serviceOrderId && args.rowData.itemCode) {
                  this.serviceOrderService.popupLoader.next(true);
                  this.inventoryService.GetOpenPartsOrderByServiceOrderId(this.data.serviceOrderId)
                    .subscribe((res: ApiResponse) => {
                      this.serviceOrderService.popupLoader.next(false);
                      if (res.isSuccessful && res.result.length) {
                        const data = res.result[0];
                        if (data.itemList.findIndex(x => x.itemCode === args.rowData.itemCode) === -1) {
                          data.itemList?.push({
                            itemCode: args.rowData.itemCode,
                            itemDescription: args.rowData.itemDescription,
                            itemGroup: args.rowData.itemGroup,
                            serviceItemGroup: args.rowData.serviceItemGroup
                          });
                        }
                        this.showPartsOrderPopup.emit({ data, update: true, serviceOrderId: this.data.serviceOrderId });
                      } else {
                        this.showPartsOrderPopup.emit({
                          update: false,
                          itemCode: args.rowData.itemCode,
                          itemDescription: args.rowData.itemDescription,
                          itemGroup: args.rowData.itemGroup,
                          serviceItemGroup: args.rowData.serviceItemGroup,
                          serviceOrderId: this.data.serviceOrderId,
                          warehouse: args.rowData.warehouse
                        });
                      }
                    });
                }
                else {
                  let warning = !this.data.serviceOrderId && 'Please save the service order before creating a parts order!' || !args.rowData.itemCode && 'Select an item for this transaction first!';
                  this.commonService.showNotification('warning', warning);
                }
              }
            }
          }
          else {
            this.commonService.showNotification('warning', res.message)
          }
        });

    } else if (args.commandColumn.title === 'Edit Assignment Detail') {
      args.cancel = true;
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        if (!this.assignmentDetailsGrid.isEdit && !this.assignmentEditing) {
          this.showAssignmentDetailsPopup = true;
          this.selectedAssignmentDetail = args.rowData;
        } else {
          this.commonService.showNotification('warning', 'Assignment or Transaction is in edit mode!');
        }
      }
    } else if (args.commandColumn.title === 'Delete Detail') {
      this.assignmentDetailAction = 'Delete';
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        this.deleteTransaction(args.rowData);
      }
    }
  }

  checkBillable() {
    return this.assignments.length && this.assignments.find(assignment => this.getRefActivityCategory(assignment.referenceActivityCode) === 'Billable Service');
  }

  onTransactionGridActionComplete(args, grid) {
    if (args.requestType === 'save') {
      delete this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'];
      this.assignmentDetailsGrid.allowReordering = true;
      this.assignmentDetailsGrid.allowSorting = true;
      this.assignmentDetailsGrid.allowFiltering = true;

      const rowData = grid.dataSource.find(row => row.rowId === args.data.rowId);
      rowData.assignmentId = +(this.assignmentId ?? rowData.assignmentId);
      rowData.activityId = this.activityId ?? rowData.activityId;

      if (!this.assignmentDetailsGrid.getColumnByField('unit').visible) {
        rowData.unit = this.getUnit(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('warrantyCoverage').visible) {
        rowData.warrantyCoverage = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('contractCoverage').visible) {
        rowData.contractCoverage = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('totalAmount').visible) {
        rowData.totalAmount = this.totalAmountValue || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('taxpercent').visible) {
        rowData.taxpercent = this.getTaxRate(rowData.costType);
      }

      this.taxAmount = +(rowData.totalAmount * (this.getTaxRate(rowData.costType) / 100)).toFixed(2);
      rowData.taxAmount = this.taxAmount || 0;

      if (!this.assignmentDetailsGrid.getColumnByField('costComponent').visible) {
        rowData.costComponent = this.getCostComponent(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('warehouse').visible) {
        rowData.warehouse = this.getWarehouse(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('laborType').visible) {
        rowData.laborType = this.getLaborType(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('task').visible) {
        rowData.task = this.getTask(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('startDate').visible) {
        rowData.startDate = rowData.startDate ? rowData.startDate : this.assignmentDetailStartTimeValue;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('customerCurrency').visible) {
        rowData.customerCurrency = this.customerCurrency;
      }
      rowData.assignmentDetailId = this.assignmentDetailId || rowData.assignmentDetailId;
      rowData.serviceTypeDescription = this.assignmentDetailServiceTypDescription || rowData.serviceTypeDescription;
      rowData.itemGroup = this.itemGroup || rowData.itemGroup;
      rowData.serviceItemGroup = this.serviceItemGroup;
      rowData.referenceActivityCode = this.assignmentDetailReferenceActivityCode || rowData.referenceActivityCode;
      rowData.referenceActivityDescription = this.assignmentDetailReferenceActivityDescription || rowData.referenceActivityDescription;
      rowData.serviceTypeCode = this.assignmentDetailServiceTypeCode || rowData.serviceTypeCode;
      // rowData.estQ
      rowData.transactionDescription = rowData.description;
      rowData.isDeleted = false;
      rowData.discountAmount = rowData.discountAmount ?? 0;
      rowData.iscDiscountAmount = rowData.iscDiscountAmount ?? 0;
      this.calculateAmounts(false);
      this.isTabValid = true;
      grid.refreshColumns();
      this.tempUnit = '';
      this.resetTempValuesForTransaction();
      this.serviceItemGroup = '';
      this.rowServiceItemGroup = '';
    } else if (args.requestType === 'cancel') {
      this.assignmentDetailsGrid.allowReordering = true;
      this.assignmentDetailsGrid.allowSorting = true;
      this.assignmentDetailsGrid.allowFiltering = true;
      this.resetTempValuesForTransaction();
      // Fixed (Martin, 2026-10-28): Esc on a transaction not saved to the server yet deleted it. A new row is the grid's
      // own new row and never reaches this list until saved, so a cancel only drops the edit.
      this.resetTempValuesForTransaction();
    } else if (args.requestType === 'beginEdit') {
      if (args.rowData && args.rowData.referenceActivityDescription) {
        this.USER.company === Companies.conway && this.updateCostTypeDataSource({ itemData: args.rowData }); // we are only using itemData so I am passing an object with itemData to successfully execute this function
      }
      if (this.USER.company === Companies.kingslynn) {
        this.setAdvancedSearchVisible(true);
        this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = args.rowData.discountAmount > 0;
        this.discountAmountObject.enabled = this.getRefActivityCategory(args.rowData.referenceActivityCode) === 'Billable Service' || args.rowData.serviceItemGroup === '250SVC';
      } else if (this.USER.company === Companies.conway) {
        if (args.rowData.costType === CostTypes.material) {
          this.setAdvancedSearchVisible(true);
        }
      }
      if (this.defaultReferenceActivity) {
        this.assignmentObject.value = this.defaultReferenceActivity.tempId;
        this.defaultReferenceActivity = null;
      }
    }
  }

  resetTempValuesForTransaction() {
    this.assignmentDetailServiceTypDescription = this.itemGroup = this.serviceItemGroup = this.rowServiceItemGroup
      = this.assignmentDetailReferenceActivityCode = this.assignmentDetailReferenceActivityDescription
      = this.assignmentDetailServiceTypeCode = this.costTypeObject = this.itemCodeObject = this.itemDescriptionObject
      = this.commentsObject = this.quantityObject = this.priceObject = this.discountAmountObject = this.contractAmountObject
      = this.warrantyAmountObject = this.totalAmountObject = this.returnReasonObject = this.unitObject = this.assignmentObject
      = this.assignmentDetailStartTimeObject = this.assignmentDetailEndTimeObject = this.taskObject = this.taxObject
      = this.taxPercentObject = this.transactionWarehouseObject = this.laborTypeObject = this.assignmentId = this.assignmentDetailId = null;
  }

  onAssignmentDetailDoubleClick(args: any) {
    if (this.isEditable) {
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        this.selectedAssignmentDetail = args.rowData;
        this.showAssignmentDetailsPopup = true;
      }
    }
  }

  saveAssignment(args: any) {
    const index = this.assignments.findIndex(assign => (args.data.assignmentId && assign.assignmentId === args.data.assignmentId) || assign.tempId === args.data.tempId);
    const assignment = {
      ...args.data,
      activityId: args.data.activityId || (this.assignments.length + 1) * 10,
      assignmentId: args.data.assignmentId || 0,
      isDeleted: false
    };
    // The Assignments grid finds rows by rowId.
    assignment.rowId = assignment.rowId || this.getMaxRowId(this.assignments) + 1;
    if (index > -1) {
      this.assignments.splice(index, 1, assignment);
    } else {
      this.assignments.push(assignment);
    }
    if (args.deleteTransactions) {
      this.deleteAssignmentDetailsByAssignment(args.data);
    }
    this.refreshAssignmentsGrid();
    this.emitData();
  }

  saveAssignmentDetail(data: any) {
    this.costComponentValue = data.costComponent;
    data.transactionDescription = data.description;
    data.isDeleted = false;
    if (data.costType !== 'Material') {
      data.itemDescription = this.getItemDescription(data.costType);
    }
    const existingTransactionIndex = this.assignmentDetails.findIndex(tran => (tran.assignmentDetailId && tran.assignmentDetailId === data.assignmentDetailId) || (data.rowId && tran.rowId === data.rowId));
    if (existingTransactionIndex > -1) {
      this.assignmentDetails[existingTransactionIndex] = data;
    } else {
      // data.tempId = this.assignmentDetails.length + 1;
      this.assignmentDetails?.push(data);
    }
    this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
    this.assignmentDetailsGrid.refresh();
    this.calculateAmounts(false);
    // this.emitData();
    this.serviceOrderService.popupLoader.next(false);
  }

  calculateAmounts(isInitialLoad: boolean) {
    this.data.salesAmount = 0;
    this.data.discountAmount = 0;
    this.data.warrantyCoverage = 0;
    this.data.contractCoverage = 0;
    this.data.tax = 0;
    this.assignmentDetails.filter(detail => !detail.isDeleted && detail.qty).forEach(row => {
      this.data.salesAmount += row.qty * row.price;
      this.data.discountAmount += row.discountAmount;
      this.data.warrantyCoverage += row.warrantyCoverage;
      this.data.contractCoverage += row.contractCoverage;
      this.data.tax += row.taxAmount;
    });
    this.data.salesAmount = +this.data.salesAmount?.toFixed(2);
    this.data.discountAmount = +this.data.discountAmount?.toFixed(2);
    this.data.warrantyCoverage = +this.data.warrantyCoverage?.toFixed(2);
    this.data.contractCoverage = +this.data.contractCoverage?.toFixed(2);
    this.data.tax = +this.data.tax?.toFixed(2);

    this.data.totalAmount = this.data.salesAmount - this.data.warrantyCoverage - this.data.contractCoverage - this.data.discountAmount;
    this.data.invoiceAmount = +(this.data.totalAmount + this.data.tax)?.toFixed(2);

    if (!isInitialLoad) {
      this.emitData();
    }
  }

  emitData() {
    this.tabUpdated.emit({
      ...this.data,
      assignments: this.assignments,
      assignmentDetails: this.assignmentDetails
    });
  }

  deleteAssignment(data: any) {
    this.commonService.showConfirmation('Are you sure you want to delete this assignment? Corresponding transactions will also be deleted!')
      .then(result => {
        if (result.isConfirmed) {
          const index = this.assignments.findIndex(assgn => assgn.rowId === data.rowId);
          if (index > -1) {
            this.deleteAssignmentDetailsByAssignment(data);
            if (this.assignments[index].assignmentId) {
              this.assignments[index].isDeleted = true;
            } else {
              this.assignments.splice(index, 1);
            }
            this.updateActivityId();
            this.emitData();
            this.refreshAssignmentsGrid();
          }
        }
      });
  }

  deleteAssignmentDetailsByAssignment(assignment: any) {
    // Fixed (Martin, 2026-10-28): splicing a copy by the original's index removed the wrong rows when the assignment had
    // two or more unsaved transactions. Same rule: a saved transaction is marked deleted, an unsaved one is dropped.
    const details = this.assignmentDetails.filter(detail => {
      if (detail.assignmentId === assignment.tempId || detail.assignmentId === assignment.assignmentId) {
        if (detail.assignmentDetailId) {
          detail.isDeleted = true;
          return true;
        }
        return false;
      }
      return true;
    });
    this.assignmentDetails = details;
    this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
    this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
    this.calculateAmounts(false);
    this.assignmentDetailsGrid.refresh();
  }

  updateActivityId() {
    this.assignments.filter(assign => !assign.isDeleted).forEach((row, index) => {
      row.activityId = (index + 1) * 10;
      this.updateDetailsOnAssignmentDeletion(row);
      return row;
    });
  }

  updateDetailsOnAssignmentDeletion(assignment) {
    this.assignmentDetails.map(det => {
      if (assignment.tempId === det.assignmentId) {
        det.activityId = assignment.activityId;
      }
    });
  }

  deleteTransaction(data) {
    this.commonService.showConfirmation('Are you sure you want to delete this transaction?')
      .then(result => {
        if (result.isConfirmed) {
          const index = this.assignmentDetails.findIndex(assgnDet => assgnDet.rowId === data.rowId);
          if (index > -1) {
            if (this.assignmentDetails[index].assignmentDetailId) {
              this.assignmentDetails[index].isDeleted = true;
            } else {
              this.assignmentDetails.splice(index, 1);
            }
            this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
            this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
            this.assignmentDetailsGrid.refresh();
            this.calculateAmounts(false);
          }
        }
      })
  }

  onClose() {
    //   this.showPartsOrderPopup  = false;
  }

  partsOrderSaved(updatedData) {
  }

  hasTransaction(assignment) {
    const index = (this.assignmentDetailsGrid.dataSource as any).findIndex(ad => ad.assignmentId === assignment.tempId);
    return index > -1;
  }

  updateRefActivityDS(existingRefActivities) {
    const createdDate = new Date(this.data?.orderDateLN ? this.data?.orderDateLN : this.data?.soCreatedDate).setHours(0, 0, 0, 0);
    return this.referenceActivities.filter(activity => {
      if (activity.description === 'Contract Service' && this.equipmentInfoData) {
        if (this.equipmentInfoData?.serviceContractCode && this.equipmentInfoData.serviceContractDescriptionObj && this.equipmentInfoData.serviceContractDescriptionObj.length) {
          const index = this.equipmentInfoData.serviceContractDescriptionObj.findIndex(contract => new Date(contract.expiryDate) >= new Date(createdDate));
          return index > -1 ? !existingRefActivities.includes(activity.value) : false;
        } else {
          return false;
        }
      } else if (activity.description === 'Warranty Service' && this.equipmentInfoData) {
        if (this.equipmentInfoData.warrantyCode && this.equipmentInfoData.warrantyDescriptionObj && this.equipmentInfoData.warrantyDescriptionObj.length) {
          const index = this.equipmentInfoData.warrantyDescriptionObj.findIndex(warranty => new Date(warranty.expiryDate) >= new Date(createdDate));
          return index > -1 ? !existingRefActivities.includes(activity.value) : false;
        } else {
          return false;
        }
      } else {
        return !existingRefActivities.includes(activity.value);
      }
    });
  }

  editAssignment(): CellEdit {
    return {
      read: () => this.assignmentObject?.value,
      destroy: () => this.assignmentObject?.destroy(),
      open: args => {
        return this.assignmentObject = new DropdownEditor({
          dataSource: this.assignments.filter(assignment => !assignment.isDeleted),
          fields: { value: 'tempId', text: 'referenceActivityDescription' },
          value: args.rowData.assignmentId,
          allowFiltering: true,
          popupWidth: '250px',
          change: event => {
            this.USER.company === Companies.conway && this.updateCostTypeDataSource(event);
            this.activityId = event.itemData.activityId;
            this.assignmentId = +event.itemData.tempId;
            this.assignmentDetailServiceTypeCode = event.itemData.serviceTypeCode;
            this.assignmentDetailReferenceActivityDescription = event.itemData.referenceActivityDescription;
            this.assignmentDetailReferenceActivityCode = event.itemData.referenceActivityCode;
            this.assignmentDetailServiceTypDescription = event.itemData.serviceTypeDescription;
            if (args?.rowData.assignmentDetailId) { // To reset the row on this change
              this.costTypeObject.value = null;
            }
            if (this.discountAmountObject) {
              this.discountAmountObject.enabled = this.getRefActivityCategory(event.itemData.referenceActivityCode) === 'Billable Service';
            }
            // const linkedAssignmentId = this.assignments.find(x => x.tempId === +event.itemData.tempId).assignmentId;
            if (!event.itemData.assignmentId) {
              this.assignmentDetailId = 0;
            }
            this.recalculations(args);
          }
        });
      }
    }
  }

  recalculations(args) {
    // do all the recalculations based on the category of the transaction (Billable Service, Contract Service, Warranty Service or Other)

    const qty = this.quantityObject ? this.quantityObject.value : args.rowData.qty;
    const price = this.priceObject ? this.priceObject.value : args.rowData.price;
    let discount = this.discountAmountObject ? this.discountAmountObject.value : args.rowData.discountAmount;
    const tax = this.getTaxRate(this.costTypeObject.value);
    const warranty = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.quantityObject.value * (this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0) || 0;
    const contract = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.quantityObject.value * (this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0) || 0;

    if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
      discount = price * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = price && qty ? price * qty : 0;
        this.discountAmountObject.max = price && qty ? price * qty : null;
      }
    }

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, price, discount, tax, warranty, contract });
  }

  checkWarrantyContractCoverage(coverages) {
    let costTypes = this.costTypes;
    const createdDate = new Date(this.data?.orderDateLN ? this.data?.orderDateLN : this.data?.soCreatedDate).setHours(0, 0, 0, 0);
    coverages.forEach(x => {
      if (x.costType === 'all' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = [];
      } else if (x.costType.toLowerCase() === 'material' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = costTypes.filter(x => x.value !== 'Material');
      } else if (x.costType.toLowerCase() === 'labor' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = costTypes.filter(x => x.value !== 'Labor');
      } else if (x.costType.toLowerCase() === 'travel' && new Date(x.expiryDate) < new Date(createdDate)) { // Update the data (Instead of travel it should be callOut from the API.)
        costTypes = costTypes.filter(x => x.value !== 'CallOut');
      }
    });
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'material') === -1) {
      costTypes = costTypes.filter(x => x.value !== CostTypes.material);
    }
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'labor') === -1) {
      costTypes = costTypes.filter(x => x.value !== CostTypes.labor);
    }
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'travel') === -1) {
      costTypes = costTypes.filter(x => x.value !== 'CallOut');
    }
    return costTypes;
  }

  updateCostTypeDataSource(args) {
    if (args.itemData.referenceActivityDescription === 'Warranty Service' && this.equipmentInfoData) {
      this.costTypeObject.dataSource = this.checkWarrantyContractCoverage(this.equipmentInfoData.warrantyDescriptionObj);
    } else if (args.itemData.referenceActivityDescription === 'Contract Service' && this.equipmentInfoData) {
      this.costTypeObject.dataSource = this.checkWarrantyContractCoverage(this.equipmentInfoData.serviceContractDescriptionObj);
    }
  }

  editAssignmentDetailReferenceActivity(): CellEdit {
    return {
      read: () => this.assignmentDetailReferenceActivityObject?.value,
      destroy: () => this.assignmentDetailReferenceActivityObject?.destroy(),
      open: args => {
        return this.assignmentDetailReferenceActivityObject = new TextEditor({
          value: args.rowData.referenceActivityCode,
          enabled: false
        });
      }
    }
  }

  editAssignmentDetailServiceType(): CellEdit {
    return {
      read: () => this.assignmentDetailServiceTypeObject?.value,
      destroy: () => this.assignmentDetailServiceTypeObject?.destroy(),
      open: args => {
        return this.assignmentDetailServiceTypeObject = new TextEditor({
          value: args.rowData.serviceTypeDescription,
          enabled: false
        });
      }
    }
  }

  editCostType(): CellEdit {
    return {
      read: () => this.costTypeObject?.value,
      destroy: () => this.costTypeObject?.destroy(),
      open: args => {
        return this.costTypeObject = new DropdownEditor({
          dataSource: this.costTypes,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.costType,
          popupWidth: '150px',
          change: event => {
            this.quantityObject.enabled = this.isQuantityEnabled();
            this.setTransactionValues(event.value);
            if (event.value !== CostTypes.material) {
              delete this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'];
            }
            this.setItemCodeValidation(event.value);

            this.tempUnit = this.getUnit(event.value);
          }
        });
      }
    }
  }

  setItemCodeValidation(costType) {
    this.assignmentDetailsGrid.getColumnByField('itemCode').validationRules['required'] = costType === CostTypes.material || costType === CostTypes.otherCost;
  }

  /** The Item column's Advanced Search button. */
  setAdvancedSearchVisible(visible: boolean) {
    this.itemCodeObject?.actionVisible.set(visible);
  }

  setTransactionValues(costType: string) {
    if (costType === CostTypes.labor) {
      this.priceObject.value = this.laborRate;
      this.setAdvancedSearchVisible(false);
      if (this.isIsc || this.isIscManager) {
        this.subcostTypeObject.value = null;
        this.subcostTypeObject.enabled = false;
      }
    } else if (costType === CostTypes.other) {
      this.quantityObject.value = 1;
      if (this.isIsc || this.isIscManager) {
        this.subcostTypeObject.enabled = true;
        this.subcostTypeObject.value = SubCostTypes.travel;
      }
      this.setAdvancedSearchVisible(false);
      this.priceObject.value = this.calloutRate;
    } else if (costType === CostTypes.material || costType === CostTypes.otherCost) {
      this.priceObject.value = 0;
      this.setAdvancedSearchVisible(true);
      if (this.isIsc || this.isIscManager) {
        if (this.subcostTypeObject) {
          this.subcostTypeObject.value = null;
          this.subcostTypeObject.enabled = false;
        }
      }
      if (this.USER.company === Companies.kingslynn) {
        this.getItemList();
        this.quantityObject.min = costType === CostTypes.otherCost ? 1 : 0;
      }
    } else {
      this.priceObject.value = 0;
      this.setAdvancedSearchVisible(false);
    }

    if (this.itemDescriptionObject) {
      this.itemDescriptionObject.value = this.getItemDescription(costType, true);
    }

    if (this.laborTypeObject) {
      this.laborTypeObject.value = this.getLaborType(costType);
    }

    if (this.unitObject) {
      this.unitObject.value = this.getUnit(costType);
    }

    if (this.costComponentObject) {
      this.costComponentObject.value = this.getCostComponent(costType);
    }

    if (this.transactionWarehouseObject) {
      this.transactionWarehouseObject.value = this.getWarehouse(costType);
    }

    if (this.taskObject) {
      this.taskObject.value = this.getTask(costType);
    }

    this.quantityObject.value = 1;
    this.discountAmountObject.value = 0;
    this.totalAmountObject.value = 0;
    this.totalAmount = 0;

    if (this.assignmentDetailStartTimeObject) {
      this.assignmentDetailStartTimeObject.value = this.assignmentDetailStartTimeValue;
    }

    if (this.taxObject) {
      this.taxObject.value = 0;
    }

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = 0;
    }

    if (this.contractAmountObject) {
      this.contractAmountObject.value = 0;
    }
    this.taxAmount = 0;

    if (this.taxPercentObject) {
      this.taxPercentObject.value = this.getTaxRate(costType);
    }

    if (!this.isIsc && !this.isIscManager) {
      this.priceObject.enabled = !this.isKingslynn && costType === CostTypes.material;
      if (this.subcostTypeObject) {
        this.subcostTypeObject.enabled = false;
      }
    } else {
      if (costType === CostTypes.other) {
        if (this.subcostTypeObject) {
          this.subcostTypeObject.enabled = true;
        }
      } else {
        this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = false;
        if (this.commentsObject) {
          this.commentsObject.value = null;
        }
        if (this.subcostTypeObject) {
          this.subcostTypeObject.value = null;
          this.subcostTypeObject.enabled = false;
        }
      }
    }

    if (this.returnReasonObject) {
      this.returnReasonObject.enabled = costType === CostTypes.material;
    }

    this.itemCodeObject.value = null;
    this.itemCodeObject.enabled = costType === CostTypes.material || costType === CostTypes.otherCost;

    this.quantityObject.format = costType === CostTypes.material ? 'n' : 'n2';
    this.quantityObject.step = costType === CostTypes.material ? 1 : 0.1;
    this.quantityObject.decimals = costType === CostTypes.material ? 0 : 2;

    this.priceObject.enabled = this.isOffline && (this.isIsc || this.isIscManager);
  }

  editSubCostType(): CellEdit {
    return {
      read: () => this.subcostTypeObject?.value,
      destroy: () => this.subcostTypeObject?.destroy(),
      open: args => {
        return this.subcostTypeObject = new DropdownEditor({
          dataSource: SubCostTypeList,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.subCostType || '',
          popupWidth: '150px',
          change: event => {
            this.quantityObject.enabled = this.isQuantityEnabled();
            const isNumber = this.costTypeObject.value === CostTypes.material ? true : false;
            this.quantityObject.format = isNumber ? 'n' : 'n2';
            this.quantityObject.step = isNumber ? 1 : 0.1;
            this.quantityObject.decimals = isNumber ? 0 : 2;
            switch (event.value) {
              case SubCostTypes.travel:
                // same as FST
                if (this.descriptionObject)
                  this.descriptionObject.value = "Travel call-out charge";
                this.priceObject.enabled = this.isOffline;
                this.priceObject.value = this.calloutRate;
                this.quantityObject.value = 1;
                break;
              case SubCostTypes.mileage:
                // get mileageRate form this.USER into price
                // quantity is mandatory
                if (this.descriptionObject)
                  this.descriptionObject.value = null;
                this.priceObject.value = this.USER.mileageRate;
                break;
              case SubCostTypes.tax:
                // price will be the sum of taxAmount of all transactions.
                // price will be editable/enabled:true
                if (this.descriptionObject)
                  this.descriptionObject.value = null;
                this.priceObject.enabled = true;
                this.priceObject.value = this.getTotalTaxAmount();
                break;
              case SubCostTypes.miscellaneous:
              case SubCostTypes.install:
              case SubCostTypes.freight:
                // price will be enabled and mandatory
                // comments will be enabled and mandatory
                this.priceObject.value = 0;
                if (event.value === SubCostTypes.miscellaneous) {
                  if (this.commentsObject)
                    this.commentsObject.enabled = true;
                  this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = true;
                }
                if (this.descriptionObject)
                  this.descriptionObject.value = null;
                this.priceObject.enabled = true;
                this.assignmentDetailsGrid.getColumnByField('price').validationRules['required'] = true;
                break;
            }
          }
        });
      }
    }
  }

  getTotalTaxAmount() {
    let tax = 0;
    (this.assignmentDetailsGrid?.dataSource as any)?.forEach(trasaction => {
      tax += trasaction.taxAmount;
    });
    return +tax?.toFixed(2);
  }

  showItemPopup() {
    if (this.costTypeObject && this.costTypeObject.value && this.costTypeObject.value === CostTypes.otherCost) {
      this.serviceItemGroup = '350SVC';
    } else {
      this.serviceItemGroup = '';
    }
    this.showItemAdvancedSearchPopup = true;
  }

  onItemAdvancedSearchPopupClose(data: any) {
    this.itemChangedFromAdvanceSearch = true;
    this.rowServiceItemGroup = data?.serviceItemGroup;
    if (this.assignmentDetailsGrid.isEdit) {
      this.serviceOrderService.popupLoader.next(true);
      if (data) {
        this.itemDescriptionObject.value = data?.itemDescription;
        this.itemCodeObject.dataSource = [{
          text: `${data?.item} | ${data?.itemDescription}`,
          value: data?.item,
          ...data
        }];
        this.itemCodeObject.value = data?.item;
        if (this.isKingslynn) {
          this.discountAmountObject.enabled = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service' || data.serviceItemGroup === '250SVC';
        }
      }
      setTimeout(() => {
        if (this.isKingslynn && data && this.coreItemGroup.includes(data?.serviceItemGroup)) {
          this.commonService.showNotification('warning', 'Return Required', 'center', 5000);
        }
        this.showItemAdvancedSearchPopup = false;
        this.serviceOrderService.popupLoader.next(false);
      }, 400);
    } else {
      const rowIndex = this.assignmentDetailsGrid.getRowIndexByPrimaryKey(this.selectedRowId);
      this.serviceOrderService.popupLoader.next(true);
      this.showItemAdvancedSearchPopup = false;
      setTimeout(() => {
        this.assignmentDetailsGrid.selectRow(rowIndex);
        this.skipBeginEditEvent = true;
        this.assignmentDetailsGrid.startEdit();
        if (data) {
          setTimeout(() => {
            if (this.isKingslynn) {
              this.coreItemGroup.includes(data?.serviceItemGroup)
                && this.commonService.showNotification('warning', 'Return Required', 'center', 5000);
              this.discountAmountObject.enabled = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service' || data.serviceItemGroup === '250SVC';
            }
            this.serviceOrderService.popupLoader.next(false);
            this.itemDescriptionObject.value = data?.itemDescription;
            this.itemCodeObject.dataSource = [{
              text: `${data?.item} | ${data?.itemDescription}`,
              value: data?.item,
              ...data
            }];
            this.itemCodeObject.value = data?.item;
          }, 400);
        } else {
          this.serviceOrderService.popupLoader.next(false);
        }
      }, 2000);
    }
  }

  editItem(): CellEdit {
    return {
      read: () => this.itemCodeObject?.value,
      destroy: () => this.itemCodeObject?.destroy(),
      open: args => {
        this.selectedRowId = args.rowData?.rowId;
        // The Advanced Search button starts hidden; the cost type shows it (setTransactionValues, beginEdit).
        return this.itemCodeObject = new DropdownEditor({
          dataSource: this.itemsList,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.itemCode,
          allowFiltering: true,
          showClearButton: true,
          popupWidth: '350px',
          openOnFocus: true,
          enabled: this.costTypeObject.value === CostTypes.material || this.costTypeObject.value === CostTypes.otherCost,
          filtering: args => { this.onItemUpdate.next(args.text) },
          action: { title: 'Advanced Search', iconClass: 'fas fa-info', click: () => this.showItemPopup() },
          change: event => {
            if (!event.value)
              return;
            this.getPriceForItem = event.isInteracted || this.itemChangedFromAdvanceSearch;
            if (!this.isIsc && !this.isIscManager && this.costTypeObject.value !== CostTypes.otherCost && this.data.mode === 'Actual') {
              this.checkOnHandQuantity(event.itemData?.value, args.rowData.qty, args.rowData.issuedQty, args.rowData);
            }
            const unit = this.tempUnit;
            if (event.itemData?.value !== 'LOCAL' && this.getPriceForItem) {
              this.getItemPrice(event.itemData?.value, unit, args.rowData, this.quantityObject.value);
            }
            if (this.isKingslynn && event.itemData && this.coreItemGroup.includes(event.itemData.serviceItemGroup)) {
              this.commonService.showNotification('warning', 'Return Required', 'center', 5000);
            }
            this.itemDescriptionObject.value = event.itemData?.itemDescription ? event.itemData.itemDescription : null;
            this.serviceItemGroup = event.itemData?.serviceItemGroup;
            this.rowServiceItemGroup = event.itemData?.serviceItemGroup;
            this.itemGroup = event.itemData?.itemGroup;
            if (this.discountAmountObject && this.isKingslynn) {
              this.discountAmountObject.enabled = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service' || event.itemData.serviceItemGroup === '250SVC';
            }
            this.itemChangedFromAdvanceSearch = false;
          }
        });
      }
    }
  }

  getItemPrice(itemCode, unit, rowData, quantity = 1) {
    const data = {
      company: this.USER.company,
      item: itemCode,
      unit: unit,
      quantity,
      configuration: this.data.customerCode
    };
    if (quantity) {
      this.showLoader = true;
      this.serviceOrderService.getPrice(data)
        .subscribe((res: ApiResponse) => {
          if (res && res.isSuccessful && res.result) {
            this.priceObject.value = res.result.bookPrice ? +res.result.bookPrice.bookPriceValue?.toFixed(2) : 0;
            this.discountAmountObject.value = res.result?.discountAmount ? +res.result.discountAmount.discountAmountValue?.toFixed(2) : 0;
          } else {
            this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
          }
          this.showLoader = false;
        }, (error: HttpErrorResponse) => {
          this.priceObject.value = 0;
          this.discountAmountObject.value = 0;
          this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
          this.showLoader = false;
        });
    }
  }

  checkOnHandQuantity(itemCode, rowQty = 1, issuedQty, rowData) {
    if (itemCode) {
      this.serviceOrderService.popupLoader.next(true);
      this.inventoryService.getTechnicianOnHandCount(itemCode, this.warehouse)
        .subscribe((res: ApiResponse) => {
          if (res && res.result) {
            const actualOnHand = this.updateItemOnHandQuantity(itemCode, res.result.onHandCount, rowData);//issuedQty != null ? res.result.onHandCount + issuedQty : res.result.onHandCount;
            this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'] = [actualOnHand, 'On Hand: ' + actualOnHand];
            this.onHandQuantity = actualOnHand;
            if (!actualOnHand) {
              this.quantityObject && (this.quantityObject.value = 0);
              this.totalAmountObject && (this.totalAmountObject.value = 0);
            } else {
              this.quantityObject && (this.quantityObject.value = rowQty);
            }
          } else {
            if (this.costTypeObject && this.costTypeObject.value === CostTypes.material) {
              this.onHandQuantity = 0;
              this.quantityObject && (this.quantityObject.value = 0);
              this.totalAmountObject && (this.totalAmountObject.value = 0);
              this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'] = [0, 'On Hand: ' + 0];
            }
          }
          this.serviceOrderService.popupLoader.next(false);
        }, (error: HttpErrorResponse) => {
          if (this.costTypeObject && this.costTypeObject.value === CostTypes.material) {
            this.onHandQuantity = 0;
            this.quantityObject && (this.quantityObject.value = 0);
            this.totalAmountObject && (this.totalAmountObject.value = 0);
            this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'] = [0, 'On Hand: ' + 0];
          }
          this.serviceOrderService.popupLoader.next(false);
          throw error;
        });
    }
  }

  updateItemOnHandQuantity(itemCode, onHandQty, rowData) {
    let calculatedOnHand = onHandQty;
    this.loadedAssignmentItemDetails.forEach(x => {
      if (itemCode === x.itemCode) {
        calculatedOnHand += x.issuedQty;
      }
    });
    (this.assignmentDetailsGrid.dataSource as any).forEach(x => {
      if (itemCode === x.itemCode && !x.isDeleted) {
        if (!this.assignmentDetailsGrid.isEdit || rowData.rowId != x.rowId)
          calculatedOnHand -= x.qty;
      }
    });
    return calculatedOnHand;
  }

  editItemDescription(): CellEdit {
    return {
      read: () => this.itemDescriptionObject?.value,
      destroy: () => {
        this.itemDescriptionObject?.destroy();
        this.itemDescriptionObject = null;
      },
      open: args => {
        return this.itemDescriptionObject = new TextEditor({
          value: args.rowData.itemDescription,
          enabled: false
        });
      }
    }
  }

  editComments(): CellEdit {
    return {
      read: () => this.commentsObject?.value,
      destroy: () => this.commentsObject?.destroy(),
      open: args => {
        return this.commentsObject = new TextEditor({
          value: args.rowData.comments,
        });
      }
    }
  }

  editQuantity(): CellEdit {
    return {
      read: () => this.quantityObject?.value,
      destroy: () => {
        this.onHandQuantity = undefined;
        this.quantityObject?.destroy();
      },
      open: args => {
        const isNumber = this.costTypeObject.value === CostTypes.material ? true : false;
        return this.quantityObject = new NumberEditor({
          value: args.rowData.qty,
          format: isNumber ? 'n' : 'n2',
          min: 0,
          step: isNumber ? 1 : 0.1,
          decimals: isNumber ? 0 : 2,
          enabled: this.isQuantityEnabled(),
          // Typing is applied after a 200 ms pause, as the old keyup handler did (each change asks for the price).
          typingDelay: 200,
          // The On Hand count, for a Material row once it is known (the old focus tooltip).
          hint: () => this.costTypeObject?.value === CostTypes.material && this.onHandQuantity !== undefined ? 'On Hand: ' + this.onHandQuantity : null,
          change: event => {
            const qty = +event.value?.toFixed(2) || 0;
            const costType = this.costTypeObject.value;

            if (costType === CostTypes.material && this.itemCodeObject.value && qty) {
              this.tempUnit = this.getUnit(costType);
              const data = {
                company: this.USER.company,
                item: this.itemCodeObject.value,
                unit: this.tempUnit,
                quantity: qty,
                configuration: this.data.customerCode
              };
              this.showLoader = true;
              this.serviceOrderService.getPrice(data).subscribe((res: ApiResponse) => {
                if (res && res.isSuccessful && res.result) {
                  this.priceObject.value = res.result.bookPrice ? +res.result.bookPrice.bookPriceValue?.toFixed(2) : 0;
                  this.discountAmountObject.value = res.result.discountAmount ? +res.result.discountAmount.discountAmountValue?.toFixed(2) : 0;
                  this.onQuantityChange(args, qty);
                } else {
                  this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
                }
                this.showLoader = false;
              }, (error: HttpErrorResponse) => {
                this.priceObject.value = 0;
                this.discountAmountObject.value = 0;
                this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
                this.showLoader = false;
              });
            } else { // for cost types other & labor
              this.onQuantityChange(args, qty);
            }
          }
        });
      }
    }
  }

  isQuantityEnabled() {
    if (this.isKingslynn)
      return true;
    else
      return this.costTypeObject.value !== CostTypes.other;
  }

  onQuantityChange(args, qty: number = 0) {
    const price = this.priceObject ? +this.priceObject.value?.toFixed(2) : +args.rowData.price.toFixed(2);
    let discount = this.discountAmountObject ? +this.discountAmountObject.value?.toFixed(2) : +args.rowData.discountAmount.toFixed(2);
    const tax = +args.rowData.taxpercent?.toFixed(2);
    const warranty = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
    const contract = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

    if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
      discount = price * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = price && qty ? price * qty : 0;
        this.discountAmountObject.max = price && qty ? price * qty : null;
      }
    }
    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, price, discount, tax, warranty, contract });
  }

  getRefActivityCategory(refActivityCode) {
    const refActivity = this.referenceActivities.find(act => act.value === refActivityCode);
    return refActivity ? refActivity.category : '';
  }

  editPrice(): CellEdit {
    return {
      read: () => this.priceObject?.value,
      destroy: () => this.priceObject?.destroy(),
      open: args => {
        return this.priceObject = new NumberEditor({
          value: args.rowData.price,
          format: 'n2',
          min: 0,
          decimals: 2,
          enabled: !this.isKingslynn && (args.rowData.costType === CostTypes.material || this.isIsc || this.isIscManager),
          change: (event) => {
            const qty = this.quantityObject ? this.quantityObject.value : args.rowData.qty;
            const price = +event.value?.toFixed(2);
            let discount = this.discountAmountObject ? this.discountAmountObject.value : args.rowData.discountAmount;
            const tax = args.rowData.taxpercent;
            const warranty = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
            const contract = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

            if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
              discount = price * qty;
              if (this.discountAmountObject) {
                this.discountAmountObject.value = price && qty ? price * qty : 0;
                this.discountAmountObject.max = price && qty ? price * qty : null;
              }
            }
            if (this.warrantyAmountObject) {
              this.warrantyAmountObject.value = warranty;
            }
            if (this.contractAmountObject) {
              this.contractAmountObject.value = contract;
            }
            this.calculateTotalAmount({ qty, price, discount, tax, warranty, contract });
          }
        });
      }
    }
  }

  calculateTotalAmount(data) {
    const { qty, price, discount, warranty, contract, tax } = data;
    this.totalAmountValue = +(qty && (price * qty) - (discount || 0) - (warranty || 0) - (contract || 0))?.toFixed(2);
    this.taxAmount = +(this.totalAmountValue * tax / 100)?.toFixed(2);

    if (this.totalAmountObject) {
      this.totalAmountObject.value = this.totalAmountValue;
    }
  }

  editDiscountAmount(): CellEdit {
    return {
      read: () => this.discountAmountObject?.value,
      destroy: () => this.discountAmountObject?.destroy(),
      open: args => {
        return this.discountAmountObject = new NumberEditor({
          value: args.rowData.discountAmount || 0,
          format: 'n2',
          min: 0,
          decimals: 2,
          max: this.priceObject?.value && this.quantityObject?.value && this.priceObject.value * this.quantityObject.value || null,
          enabled: this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service' || args.rowData.serviceItemGroup === '250SVC',
          focus: () => {
            const price = this.priceObject && this.priceObject.value,
              qty = this.quantityObject && this.quantityObject.value;
            this.discountAmountObject.max = price && qty ? price * qty : null;
          },
          change: (event) => {
            this.discountValue = +event.value?.toFixed(2);
            const qty = this.quantityObject ? this.quantityObject.value : args.rowData.qty;
            const price = this.priceObject ? this.priceObject.value : args.rowData.price;
            let discount = +event.value?.toFixed(2);
            const tax = args.rowData.taxpercent;

            const warranty = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
            const contract = this.isKingslynn && this.rowServiceItemGroup === '250SVC' ? 0 : this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

            if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
              discount = price * qty;
              if (this.discountAmountObject) {
                this.discountAmountObject.value = price && qty ? price * qty : 0;
                this.discountAmountObject.max = price && qty ? price * qty : null;
              }
            }

            if (this.warrantyAmountObject) {
              this.warrantyAmountObject.value = warranty;
            }
            if (this.contractAmountObject) {
              this.contractAmountObject.value = contract;
            }
            this.calculateTotalAmount({ qty, price, discount, tax, warranty, contract });
            if (this.USER.company === Companies.kingslynn) {
              this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = this.discountValue > 0;
            }
          }
        });
      }
    }
  }

  editContractAmount(): CellEdit {
    return {
      read: () => this.contractAmountObject?.value,
      destroy: () => this.contractAmountObject?.destroy(),
      open: args => {
        return this.contractAmountObject = new NumberEditor({
          value: args.rowData.contractCoverage || 0,
          min: 0,
          enabled: false,
        });
      }
    }
  }

  editWarrantyAmount(): CellEdit {
    return {
      read: () => this.warrantyAmountObject?.value,
      destroy: () => this.warrantyAmountObject?.destroy(),
      open: args => {
        return this.warrantyAmountObject = new NumberEditor({
          value: args.rowData.warrantyCoverage || 0,
          min: 0,
          enabled: false,
        });
      }
    }
  }

  editTotalAmount(): CellEdit {
    return {
      read: () => this.totalAmountObject?.value,
      destroy: () => this.totalAmountObject?.destroy(),
      open: args => {
        return this.totalAmountObject = new NumberEditor({
          value: args.rowData.totalAmount,
          enabled: false,
          min: 0,
          change: (event) => {
            this.taxAmount = +(this.totalAmountObject.value * this.getTaxRate(this.costTypeObject.value) / 100)?.toFixed(2);
            if (this.taxObject) {
              this.taxObject.value = this.taxAmount;
            }
          }
        });
      }
    }
  }

  editUnit(): CellEdit {
    return {
      read: () => this.unitObject?.value,
      destroy: () => this.unitObject?.destroy(),
      open: args => {
        return this.unitObject = new DropdownEditor({
          dataSource: this.units,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.unit,
          allowFiltering: true,
          enabled: false
        });
      }
    }
  }

  editReturnReason(): CellEdit {
    return {
      read: () => this.returnReasonObject?.value,
      destroy: () => this.returnReasonObject?.destroy(),
      open: args => {
        return this.returnReasonObject = new DropdownEditor({
          dataSource: this.returnReasons,
          fields: { value: 'value', text: 'text' },
          popupWidth: '250px',
          enabled: this.costTypeObject.value === CostTypes.material,
          value: args.rowData.returnReasonCode
        });
      }
    }
  }

  editStartTime(): CellEdit {
    return {
      read: () => this.assignmentDetailStartTimeObject?.value,
      destroy: () => this.assignmentDetailStartTimeObject?.destroy(),
      open: args => {
        return this.assignmentDetailStartTimeObject = new DateTimeEditor({
          placeholder: "Select start date time...",
          value: args.rowData.startDate,
          min: args.rowData.startDate ? args.rowData.startDate : this.checkinTime,
          openOnFocus: true,
          allowEdit: false,
          change: ev => {
            this.assignmentDetailStartTimeValue = ev.value;
            if (this.assignmentDetailEndTimeObject) {
              this.assignmentDetailEndTimeObject.min = ev.value;
            }
          }
        });
      }
    }
  }

  editEndTime(): CellEdit {
    return {
      read: () => this.assignmentDetailEndTimeObject?.value,
      destroy: () => this.assignmentDetailEndTimeObject?.destroy(),
      open: args => {
        return this.assignmentDetailEndTimeObject = new DateTimeEditor({
          placeholder: "Select end date time...",
          value: args.rowData.endDate,
          min: args.rowData.startDate || new Date,
          openOnFocus: true,
          allowEdit: false,
          change: ev => {
            if (this.assignmentDetailStartTimeObject) {
              this.assignmentDetailStartTimeObject.max = ev.value;
            }
          }
        });
      }
    }
  }

  editTask(): CellEdit {
    return {
      read: () => this.taskObject?.value,
      destroy: () => this.taskObject?.destroy(),
      open: args => {
        return this.taskObject = new TextEditor({
          value: args.rowData.task,
          enabled: false
        });
      }
    }
  }

  editTax(): CellEdit {
    return {
      read: () => this.taxObject?.value,
      destroy: () => this.taxObject?.destroy(),
      open: args => {
        return this.taxObject = new NumberEditor({
          value: args.rowData.taxAmount,
          enabled: false,
          change: args => {
          }
        });
      }
    }
  }

  editTaxPercent(): CellEdit {
    return {
      read: () => this.taxPercentObject?.value,
      destroy: () => this.taxPercentObject?.destroy(),
      open: args => {
        return this.taxPercentObject = new NumberEditor({
          value: args.rowData.taxpercent,
          enabled: false,
          change: args => {
          }
        });
      }
    }
  }

  editCostComponent(): CellEdit {
    return {
      read: () => this.costComponentObject?.value,
      destroy: () => this.costComponentObject?.destroy(),
      open: args => {
        return this.costComponentObject = new TextEditor({
          value: args.rowData.costComponent,
          enabled: false
        });
      }
    }
  }

  editTransactionWarehouse(): CellEdit {
    return {
      read: () => this.transactionWarehouseObject?.value,
      destroy: () => this.transactionWarehouseObject?.destroy(),
      open: args => {
        return this.transactionWarehouseObject = new TextEditor({
          value: args.rowData.warehouse,
          enabled: false
        });
      }
    }
  }

  editLaborType(): CellEdit {
    return {
      read: () => this.laborTypeObject?.value,
      destroy: () => this.laborTypeObject?.destroy(),
      open: args => {
        return this.laborTypeObject = new TextEditor({
          value: args.rowData.laborType,
          enabled: false
        });
      }
    }
  }

  ngOnDestroy() {
    this.loadedAssignmentItemDetails = null;
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }
}
